import { JSXElementConstructor, Key, ReactElement, ReactFragment, ReactPortal, useEffect, useMemo, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik, useField, useFormikContext, useFormik } from "formik";
import * as Yup from "yup";
import {
  Alert,
  Autocomplete,
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { EDialogAction } from "../Enum/DialogActionEnum";
import TextField from "@mui/material/TextField";
import useQuery from "../../Hooks/useQueryHook/useQueryHook";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@mui/icons-material/Cancel";
import { useFilePicker } from "use-file-picker";
import {
  AttachmentTagEnum,
  CountryCodeDisplayEnum,
  CountryCodeEnum,
  ProcessEnum,
  ProcessEnumDisplayLabel,
  SkillLevelDisplayEnum,
  SkillLevelEnum,
} from "../../Types/Enum";
import { useSnackbar } from "notistack";
import { CustomDatePicker } from "../DatePickerCustom/CustomDatePicker";
import { useNavigate } from "react-router";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { AttachFile, CancelOutlined, DeleteOutline, InfoRounded, OpenInBrowser, OpenInNew, PlusOneRounded } from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import { all } from "axios";
import { debounce, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px",
    padding: "1px",
  },

  disabled: {
    "& input:disabled": {
      color: "red",
    },
  },
  autoComplete: {
    height: 20,
  },
  checkboxLabel: {
    fontSize: 13,
  },
  // underline: {
  //   "&:before": {
  //     borderBottom: "none", // Remove underline before
  //   },
  //   "&:after": {
  //     borderBottom: "none", // Remove underline after
  //   },
  // },
}));

const theme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "red" },
      },
    },
  },
});

const defaultSrc =
  "https://www.pngkit.com/png/full/301-3012694_account-user-profile-avatar-comments-fa-user-circle.png";
interface CheckedSkills {
  [key: string]: boolean;
}
interface IChild {
  name: string;
  dob: string;
  gender: string;
}

interface ILanguage {
  name: string;
  level: string;
}

const ResumeDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const limit = 20;
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const themePage = useTheme();
  const classes = useStyles();
  const query = useQuery();
  const navigate = useNavigate();
  //   const [type, setType] = useState("dom");
  const [resume, setResume] = useState(props.data);
  const [jobTitleList, setJobTitleList] = useState<any[]>([]);
  const [jobTitleListForOther, setJobTitleListForOther] = useState<any[]>([]);
  const [skillList, setSkillList] = useState<any[]>([]);
  const [jobSkillList, setJobSkillList] = useState<any>({})
  const [jobDataLoading, setJobDataLoading] = useState(false)
  const [attachmentLoading, setAttachmentLoading] = useState(false)
  const [passportLoading, setPassportLoading] = useState(false)
  const [subAgentList, setSubAgentList] = useState<any[]>([]);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [jobList, setJobList] = useState<any[]>([]);
  const [countryProcessList, setCountryProcessList] = useState<any[]>([]);
  const [allRejected, setAllRejected] = useState(false);
  const [resumeCountryProcessList, setResumeCountryProcessList] = useState<
    any[]
  >([]);
  const [countryProcessId, setCountryProcessId] = useState<any[]>([]);
  // const [jobId, setJobId] = useState<any[]>([]);
  const [jobId, setJobId] = useState();
  const [jobTitle, setJobTitle] = useState("");
  const [subAgent, setSubAgent] = useState<any>({});
  const [attachmentURL, setAttachmentURL] = useState("");
  const [jobTitleExtra, setJobTitleExtra] = useState<any[]>([]);
  const [jobTitleExtraTitle, setJobTitleExtraTitle] = useState("");
  const [jobTitleExtraChecked, setJobTitleExtraChecked] = useState<any>([]);
  const [value, setValue] = useState("PDF");
  const [attachmentPath, setAttachmentPath] = useState("profile_pic");
  const [valueRefresh, setValueRefresh] = useState({});
  const [note, setNote] = useState("");
  const [newLanguageName, setNewLanguageName] = useState("");
  const [attachments, setAttachments] = useState<any[]>([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [startDate, setStartDate] = useState<any>(new Date(Date.now()));
  var formData = new FormData();
  const [openFileSelector, { filesContent, plainFiles, clear, loading }] =
    useFilePicker({
      multiple: true,
      accept: [
        ".jpg",
        ".png",
        ".jpeg",
        ".pdf",
        ".docx",
        ".txt",
        ".mp4",
        ".avi",
      ],
      readAs: "ArrayBuffer",
    });

  const formRef = useRef<any>();

  const [checked, setChecked] = useState(false);
  const [resumeSkillLevel, setResumeSkillLevel] = useState();
  const [checkedSkills, setCheckedSkills] = useState<CheckedSkills>({});
  const [skillResumeList, setResumeSkillList] = useState<any[]>([]);
  const [resumeSkillId, setResumeSkillId] = useState();
  const [experienceList, setExperienceList] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState("a");
  const [districts, setDistricts] = useState<any[]>([]);
  const [dvsOptions, setDvsOptions] = useState<any[]>([]);
  const [divisionOptions, setDivisionOptions] = useState<any[]>([]);
  const handleSkillLevelChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedValue(event.target.value);
  };

  const savePassportDetails = async (passportData: any) => {
    setPassportLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume/passport-update/${resume.id}`;
      const response = await axiosInstance.put(url, {
        passport_no: passportData.passport_no,
        passport_place_of_issue: passportData.passport_place_of_issue,
        passport_date_of_issue: passportData.passport_date_of_issue,
        passport_expire_date: passportData.passport_expire_date,
        no_passport: passportData.no_passport,
        awaiting_passport: passportData.awaiting_passport,
      });

      if (response.data.success) {
        enqueueSnackbar("Passport details saved successfully", {
          variant: "success",
        });
        // Update resume state to reflect changes instantly
        setResume((prevResume: any) => ({
          ...prevResume,
          passport_no: passportData.passport_no,
          passport_place_of_issue: passportData.passport_place_of_issue,
          passport_date_of_issue: passportData.passport_date_of_issue,
          passport_expire_date: passportData.passport_expire_date,
          no_passport: passportData.no_passport,
          awaiting_passport: passportData.awaiting_passport,
        }));
        return true;
      }
    } catch (error: any) {
      enqueueSnackbar(        
        error.response?.data?.error || "Failed to save passport details",
        { variant: "error" }
      );
      return false;
    } finally {
      setPassportLoading(false);
    }
  };

  // const handleSkillChange = (
  //   event: React.ChangeEvent<HTMLInputElement>,
  //   data: any
  // ) => {
  //   const skillId = data.skill_id;
  //   const isChecked = event.target.checked;

  //   setCheckedSkills((prevCheckedSkills) => ({
  //     ...prevCheckedSkills,
  //     [skillId]: isChecked,
  //   }));

  //   setResumeSkillId(data.id);
  //   createSkillLevel(isChecked, skillId, isChecked ? "good" : "not_good");
  // };

  useEffect(() => {
    setResume(props.data);
    setSkillList([]);
    if (props.data.job_title_extra) {
      setJobTitleExtraChecked(JSON.parse(props.data.job_title_extra));
    }
    if (props.data && props.data.sub_agent_id) {
      getSubAgentById(props.data.sub_agent_id);
    }
  }, [props.data]);


  // useEffect(() => {
  //   getSkillListByJobId(jobId);
  // }, [jobId]);

  useEffect(() => {
    // getResumeSkillList();
    getJobTitleList();
    getSubAgentList();
    getDistricts();
    getStaffList();
    // getSkillListByJobId(jobId);
  }, []);


  useEffect(() => {
    setSkillList([])
    getResumeSkillList();
    //getSkillListsByJobIds(jobList.map((job: any) => job.job_id));
    getSkillListsByJobIds(resumeCountryProcessList.map((countryProcess: any) => countryProcess.country_process.job_title_id), false);

    // jobList.forEach((job: any) => {
    //   getSkillListByJobId(job.job_title.id);
    // })
  }, [resumeCountryProcessList]);


  useEffect(() => {
    getResumeSkillList();
  }, [resumeSkillLevel]);

  useEffect(() => {
    getAllCountryProcessList();
  }, [props.open]);

  useEffect(() => {
    if (props.dialogAction == EDialogAction.edit) {
      getResumeSkillList()
      getJobList(resume.id);
      getAttachmentList(resume.id);
      getResumeCountryProcessList(resume.id);
      getExperienceList(resume.id);
      fetchDVS(resume.district);
      fetchDivision(resume.grama_dvs);
      // getResumeCountryProcess(resume.id);
    }
  }, [resume]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createResume = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume`;

      const res = await axiosInstance.post(url, {
        children: data.children,
        first_name: data.first_name,
        last_name: data.last_name,
        birth_of_date: data.birth_of_date,
        base_job_title: data.base_job_title,
        mobile_no1: data.mobile_no1,
        passport_no: data.passport_no,
        passport_place_of_issue: data.passport_place_of_issue,
        passport_date_of_issue: data.passport_date_of_issue,
        nic: data.nic,
        passport_expire_date: data.passport_expire_date,
        languages: data.languages,
        gender: data.gender,
        other_name: data.other_name,
        address: data.address,
        remark: data.remark,
        mobile_no2: data.mobile_no2,
        home_no1: data.home_no1,
        email_address: data.email_address,
        sub_agent_id: data.sub_agent_id,
        type_dom_corp: themePage.theme,
        place_of_birth: data.place_of_birth,
        district: data.district,
        religion: data.religion,
        marital_status: data.marital_status,
        qua: data.qua,
        look: data.look,
        height: +data.height,
        foot: +data.foot,
        height_unit: data.height_unit,
        weight: +data.weight,
        number_of_children: +data.number_of_children,
        month_salary: +data.month_salary,
        salary_currency: data.salary_currency,
        guardian_name: data.guardian_name,
        guardian_relationship: data.guardian_relationship,
        guardian_dob: data.guardian_dob,
        guardian_nic: data.guardian_nic,
        guardian_address: data.guardian_address,
        guardian_contact1: data.guardian_contact1,
        guardian_contact2: data.guardian_contact2,
        vacancy_source: data.vacancy_source,
        agreed_commission: data.agreed_commission,
        grama_dvs: data.grama_dvs,
        grama_division: data.grama_division,
        no_passport: data.no_passport,
        note: data.note
      });
      enqueueSnackbar("Resume Created Successfully!", { variant: "success" });
      handleClose("created");
    } catch (err: any) {
      enqueueSnackbar(
        `Resume Creation Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
      console.error(err);
    }
  };
  const editResume = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume/${data.id}`;

      const response = await axiosInstance.put(url, {
        children: data.children,
        first_name: data.first_name,
        last_name: data.last_name,
        birth_of_date: data.birth_of_date,
        base_job_title: data.base_job_title,
        mobile_no1: data.mobile_no1,
        passport_no: data.passport_no,
        passport_place_of_issue: data.passport_place_of_issue,
        passport_date_of_issue: data.passport_date_of_issue,
        nic: data.nic,
        passport_expire_date: data.passport_expire_date,
        languages: data.languages,
        gender: data.gender,
        other_name: data.other_name,
        address: data.address,
        remark: data.remark,
        mobile_no2: data.mobile_no2,
        home_no1: data.home_no1,
        email_address: data.email_address,
        sub_agent_id: data.sub_agent_id,
        type_dom_corp: themePage.theme,
        place_of_birth: data.place_of_birth,
        district: data.district,
        religion: data.religion,
        marital_status: data.marital_status,
        qua: data.qua,
        look: data.look,
        height: +data.height,
        foot: +data.foot,
        height_unit: data.height_unit,
        weight: +data.weight,
        number_of_children: +data.number_of_children,
        month_salary: +data.month_salary,
        salary_currency: data.salary_currency,
        guardian_name: data.guardian_name,
        guardian_relationship: data.guardian_relationship,
        guardian_dob: data.guardian_dob,
        guardian_nic: data.guardian_nic,
        guardian_address: data.guardian_address,
        guardian_contact1: data.guardian_contact1,
        guardian_contact2: data.guardian_contact2,
        vacancy_source: data.vacancy_source,
        agreed_commission: data.agreed_commission,
        grama_dvs: data.grama_dvs,
        grama_division: data.grama_division,
        no_passport: data.no_passport,
        note: data.note,
        job_title_extra: jobTitleExtraChecked,
        training_needed: data.training_needed,
        training_amount: data.training_amount,
        passport_needed: data.passport_needed,
        passport_amount: data.passport_amount,
        staff_id: data.staff_id,
        awaiting_passport: data.awaiting_passport,
      })
      enqueueSnackbar("Resume Updated Successfully!", {
        variant: "success",
      });
      getJobTitleList();
      handleClose();
    } catch (err: any) {
      enqueueSnackbar(
        `Resume Updated Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    }
  };
  const refresh = () => {
    setValueRefresh({});
  };
  const getJobTitleList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${themePage.theme}&page=${page}&items_per_page=${limit}`,
        {}
      );

      const data = response.data;
      setJobTitleList(data.result.data);
      setJobTitleListForOther(data.result.data);
    } catch (err) {
      console.log(err);
    }
  };
  const getSubAgentList = async () => {
    try {
      const response = await axiosInstance.get(`/v1/sub-agents`, {});

      const data = response.data;
      setSubAgentList(data.result.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getStaffList = async () => {
    try {
      const response = await axiosInstance.get(`/v1/staffs`, {});
      const data = response.data;
      setStaffList(data.result.data);
    } catch (err) {
      console.log(err);
    }
  };

  const addJobs = async (data: any) => {
    setJobDataLoading(true)
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-jobs`;

      const res = await axiosInstance.post(url, {
        resume_id: resume.id,
        job_id: jobId,
      });
      getJobList(resume.id);
      enqueueSnackbar(`Job Added Successfully!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(`Job Add Unsuccessful! ${err.response.data.error}`, {
        variant: "error",
      });
    } finally {
      setJobDataLoading(false)
    }
  };

  const getExperienceList = async (resumeId: String) => {
    setJobDataLoading(true)
    try {
      const response = await axiosInstance.get(
        `/v1/work-experience?resume_id=${resumeId}`,
        {}
      );

      const data = response.data;
      setExperienceList(data.result);
    } catch (err) {
      console.log(err);
    } finally {
      setJobDataLoading(false)
    }
  };

  const addExperience = async (duration: String, country: String, job_title_id: String, duration_months: String) => {
    setJobDataLoading(true)
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/work-experience`;

      const res = await axiosInstance.post(url, {
        resume_id: resume.id,
        job_title_id: job_title_id,
        duration: duration,
        duration_months: duration_months,
        note: country,
      });

      getExperienceList(resume.id);
      enqueueSnackbar(`Experience Added Successfully!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Experience Add Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setJobDataLoading(false)
    }
  };

  const addSkillTo = async () => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-skills`;

      for (const skill of skillList) {
        const res = await axiosInstance.post(url, {
          resume_id: resume.id,
          skill_id: skill.skill.id, // Assuming each skill object has an 'id' property
          skill_level: "not_good",
        });

        // const res = await axiosInstance.post(url, {
        //   resume_id: resume.id,
        //   skill_id: skillId,
        //   skill_level: "not_good",
        // });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getJobList = async (resumeId: number) => {
    setJobDataLoading(true)
    try {
      const response = await axiosInstance.get(
        `/v1/resume-jobs?resume_id=${resumeId}`,
        {}
      );

      const data = response.data;
      // if (data && data.result && data.result.length > 0) {
      //   data.result.forEach((job: any) => {
      //     getSkillListByJobId(job.job_title.id);
      //   })
      // }
      setJobList(data.result);
      setJobId(data.result[0] && data.result[0].job_id);
    } catch (err) {
      console.log(err);
    } finally {
      setJobDataLoading(false)
    }
  };

  const getAllCountryProcessList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/country-process?type=${themePage.theme}&page=${page}&items_per_page=${200}`,
        {}
      );

      const data = response.data;
      setCountryProcessList(data.result.data);
    } catch (err) {
      console.log(err);
    }
  };
  const deleteJobList = async (resumeId: number) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-jobs/${resumeId}`;

      const response = await axiosInstance.delete(url);
      getJobList(resume.id);
      refresh();
    } catch (err) {
      console.error(err);
    }
  };

  const getDistricts = async () => {
    try {
      const response = await axiosInstance.get('/v1/resume/districts');
      setDistricts(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getResumeCountryProcessList = async (resumeId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/resume-country?resume_id=${resumeId}`,
        {}
      );
      const data = response.data;
      const registeredJob = data.result.find((item: any) => item.status === 'proc');
      if (registeredJob) {
        getJobExtraList(registeredJob.country_process?.job_title_id);
      }
      setResumeCountryProcessList(data.result);
      setAllRejected(data.all_rejected);
    } catch (err) {
      console.log(err);
    }
  };

  const getJobExtraList = async (job_title_id: String) => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles/extra/${job_title_id}`,
        {}
      );

      const data = response.data;
      setJobTitleExtra(data.result.extra);
      setJobTitleExtraTitle(data.result.extra_title);
    } catch (err) {
      console.log(err);
    }
  };

  const addCountryProcess = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-country`;

      const res = await axiosInstance.post(url, {
        resume_id: resume.id,
        country_process_id: countryProcessId,
        // status: "new",
        // note: "Created",
      });
      getResumeCountryProcessList(resume.id);
      enqueueSnackbar(`Country Process Added Successfully!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Country Process Added Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    }
  };

  const gotoProcessViewPageChangeHandler = (processViewId: any) => {
    navigate({
      pathname: "/admin/process-view",
      search: `?processId=${processViewId}`,
    });
  };

  const getSubAgentById = async (subAgentId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/sub-agents/${subAgentId}`,
        {}
      );

      const data = response.data;

      setSubAgent(data.result);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCountryProcess = async (countryProcessId: number) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-country/${countryProcessId}`;

      const response = await axiosInstance.delete(url);
      getResumeCountryProcessList(resume.id);

    } catch (err) {
      console.error(err);
    }
  };
  const deleteExperience = async (ExperienceId: number) => {
    setJobDataLoading(true)
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/work-experience/${ExperienceId}`;

      const response = await axiosInstance.delete(url);
      getExperienceList(resume.id);
      enqueueSnackbar(`Experience Deltetion Successful!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Experience Deletion Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setJobDataLoading(false)
    }
  };

  const addAttachment = async (data: any) => {
    setAttachmentLoading(true)
    try {
      if (plainFiles.length != 1) {
        throw "Please Select a File";
      }
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-attachments`;
      formData.append("resume_id", resume.id);
      formData.append("note", note);
      formData.append("type", "r");
      formData.append("attachment_type", value);
      formData.append("attachment_file", plainFiles[0]);
      formData.append("attachment_tag", attachmentPath);

      await axiosInstance.post(url, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });

      clear();
      getAttachmentList(resume.id);
      enqueueSnackbar(`Attachment Added Successfully!`, {
        variant: "success",
      })
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Attachment Added Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setAttachmentLoading(false)
    }
  };
  const deleteAttachment = async (attachmentId: number) => {
    setAttachmentLoading(true)
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-attachments/${attachmentId}`;

      const response = await axiosInstance.delete(url);
      getAttachmentList(resume.id);
      enqueueSnackbar(`Attachment Deletion Successful!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Attachment Deletion Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setAttachmentLoading(false)
    }
  };
  const getAttachmentList = async (resumeId: number) => {

    if (resumeId != undefined) {
      try {

        const tags = ['profile_pic', 'full_pic', 'other', 'interview_video'];
        setAttachmentLoading(true);

        const requests = tags.map((tag) =>
          axiosInstance.get(`/v1/resume-attachments?resume_id=${resumeId}&attachment_tag=${tag}`, {})
        );

        const responses = await Promise.all(requests);
        const data = responses.flatMap((response) => response.data.result);

        setAttachments(data);
      } catch (err) {
        console.log(err);
      } finally {
        setAttachmentLoading(false);
      }
    }
  };
  const syncProcesses = async (data: any, status: ProcessEnum = ProcessEnum.processing) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process`;

      const res = await axiosInstance.post(url, {
        resume_id: resume.id,
        country_process_id: data,
        status: status,
        note: "",
        type_dom_corp: themePage.theme,
      });
      getResumeCountryProcessList(resume.id);
      //enqueueSnackbar(`Country Process ${ProcessEnumDisplayLabel[status]} Successfully!`, {
      enqueueSnackbar(`Customer ${ProcessEnumDisplayLabel[status]} Successfully!`, {
        variant: "success",
      });
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        //`Failed to ${ProcessEnumDisplayLabel[status]} Country Process! ${err.response.data.error}`,
        `Failed to ${ProcessEnumDisplayLabel[status]} Process! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    }
  };

  const getSkillListsByJobIds = async (jobIds: any[], countryProcess: boolean = false) => {
    setJobDataLoading(true)
    try {
      let jobList: { [key: string]: any } = {};
      for (const jobId of jobIds) {
        const response = await axiosInstance.get(
          `/v1/job-title-skills?${countryProcess ? `country_process=${jobId}` : `job_title_id=${jobId}`}`,
          {}
        );


        const jobSkills = response.data.result;
        jobSkills.forEach((jobSkill: any) => {
          const relatedResumeSkill = skillResumeList.find(
            (resumeSkill: any) => resumeSkill.skill_id === jobSkill.skill_id
          );

          if (relatedResumeSkill) {
            jobSkill.skill_level = relatedResumeSkill.skill_level;
          }
        });

        const data = response.data;
        jobList[jobId] = data.result;
      }
      setJobSkillList(jobList)
    } catch (err) {
      console.log(err);
    } finally {
      setJobDataLoading(false)
    }
  }

  // NOTE:  replaced following function by getSkillListsByJobIds()
  const getSkillListByJobId = async (jobId: any) => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-title-skills?job_title_id=${jobId}`,
        {}
      );

      const data = response.data;
      // update the skill list with the new skills
      setSkillList((prevSkillList) => [...prevSkillList, ...data.result]);

      const clist = JSON.parse(JSON.stringify(jobSkillList))
      setJobSkillList({ ...clist, [jobId]: data.result })
      // addSkillTo();
      // getResumeSkillList();

      // addSkillTo();
    } catch (err) {
      console.log(err);
    }
  };

  const createSkillLevel = async (
    skillId: number | string,
    selectedSkillLevel: string
  ) => {
    setJobDataLoading(true)
    try {
      const matchingSkill = skillResumeList.find(
        (skill: any) => skill.skill_id === skillId
      );
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-skills`;
      if (matchingSkill) {
        const putUrl = `${url}/${matchingSkill.id}`;
        await axiosInstance.put(putUrl, {
          skill_level: selectedSkillLevel,
        });
      } else {
        await axiosInstance.post(url, {
          resume_id: resume.id,
          skill_id: skillId,
          skill_level: selectedSkillLevel,
        });
      }
      getResumeSkillList();
    } catch (err) {
      console.error(err);
    } finally {
      setJobDataLoading(false)
    }
  };

  const getResumeSkillList = async () => {
    try {
      if (resume != null) {
        const response = await axiosInstance.get(
          `/v1/resume-skills?resume_id=${resume.id}`,
          {}
        );
        let uniqueSkills: any = [];
        const data = response.data;
        data.result.forEach((skill: any) => {
          const existingSkill = uniqueSkills.find(
            (s: any) => s.skill_id == skill.skill_id
          );
          if (!existingSkill) {
            uniqueSkills.push(skill);
          }
        });
        setResumeSkillList(uniqueSkills);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleJobListChange = async (inputValue: any, source: any) => {

    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${themePage.theme}&page=${page}&items_per_page=${limit}&keyword=${inputValue}`,
        {}
      );
      const data = response.data;

      // Update the relevant state based on the source
      if (source === 'jobTitleOther') {
        // Set the state specific to the first Autocomplete
        setJobTitleListForOther(data.result.data);
      } else if (source === 'jobList') {
        // Set the state specific to the second Autocomplete
        setJobTitleList(data.result.data);
      }
    } catch (error) {
      console.error('Error fetching job titles:', error);
    }
  };

  const handleCountryProcessesChange = async (event: any) => {
    const inputValue = event?.target?.value ?? '';
    try {
      const response = await axiosInstance.get(
        `/v1/country-process?type=${themePage.theme}&page=${page}&items_per_page=${limit}&keyword=${inputValue}`,
        {}
      );

      const data = response.data;
      setCountryProcessList(data.result.data);

    } catch (error) {
      console.error('Error fetching skills:', error);
    }
  };

  const handleCountryProcessInputChange = useMemo(
    () =>
      debounce(async (event: any, value: string, reason: string) => {
        if (reason === 'input') {
          try {
            const response = await axiosInstance.get(
              `/v1/country-process?type=${themePage.theme}&page=${page}&items_per_page=${limit}&keyword=${value}`
            );
  
            const data = response.data;
            setCountryProcessList(data.result.data);
          } catch (error) {
            console.error('Error fetching country processes:', error);
          }
        }
      }, 300),
    [themePage.theme, page, limit]
  );



  function fetchDVS(district: any) {
    if (district) {
      axiosInstance.get(`/v1/resume/dvs/${district}`)
        .then((response) => {
          setDvsOptions(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  function fetchDivision(dvs: any) {
    if (dvs) {
      axiosInstance.get(`/v1/resume/division/${dvs}`)
        .then((response) => {
          setDivisionOptions(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  return (
    <>
      {" "}
      {resume == null ? (
        <div></div>
      ) : (
        <Dialog
          maxWidth="lg"
          open={props.open}

          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          <div className="flex justify-between pr-4">
            <DialogTitle>
              {props.dialogAction == EDialogAction.edit && `Edit Resume :${props.data.id}`}
              {props.dialogAction == EDialogAction.create && `Create Resume`}
              {props.dialogAction == EDialogAction.view && `View Resume :${props.data.id}`}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => {
                handleClose();
              }}
            >
              <CancelIcon />
            </IconButton>
          </div>
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              validateOnChange
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    children: [],
                    first_name: "",
                    last_name: "",
                    birth_of_date: "",
                    base_job_title: "",
                    nic: "",
                    mobile_no1: "",
                    passport_no: "",
                    passport_place_of_issue: "",
                    passport_date_of_issue: "",
                    passport_expire_date: "",
                    //languages: "",
                    languages: [],
                    gender: "M",
                    other_name: "",
                    address: "",
                    remark: "",
                    mobile_no2: "",
                    home_no1: "",
                    email_address: "",
                    sub_agent_id: "",
                    district: "",
                    place_of_birth: "",
                    religion: "muslim",
                    marital_status: "single",
                    qua: "",
                    look: "fair",
                    height: 0,
                    foot: "",
                    height_unit: 'cm',
                    weight: 0,
                    number_of_children: +"",
                    month_salary: +"",
                    salary_currency: "LKR",
                    duration: "",
                    duration_months: "",
                    noteEx: "",
                    guardian_name: "",
                    guardian_relationship: "",
                    guardian_dob: "",
                    guardian_nic: "",
                    guardian_address: "",
                    guardian_contact1: "",
                    guardian_contact2: "",
                    vacancy_source: "",
                    agreed_commission: "",
                    grama_dvs: "",
                    grama_division: "",
                    no_passport: false,
                    training_needed: 0,
                    training_amount: "",
                    passport_needed: 0,
                    passport_amount: "",
                    awaiting_passport: false,
                    staff_id: "",
                    note: "",
                  }
                  : {
                    ...resume,
                    awaiting_passport: resume?.rec_status === "7" ? true : (resume?.awaiting_passport || false)
                  }
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                first_name: Yup.string()
                  .required("First Name is Required")
                  .max(50, "First Name must not be greater than 50 characters"),
                last_name: Yup.string()
                  .required("Last Name is Required")
                  .max(50, "Last Name must not be greater than 50 characters"),

                other_name: Yup.string()
                  .max(50, "Other Name must not be greater than 08 characters")
                  .nullable(),
                birth_of_date: Yup.date()
                  .required("Date of Birth is Required")
                  .max(new Date(), "Date of birth must be before current date"),
                // base_job_title: Yup.string()
                //   .required("Job Title is Required")
                //   .max(
                //     100,
                //     "Job Title must not be greater than 100 characters"
                //   ),
                mobile_no1: Yup.string()
                  .required("Mobile Number is Required")
                  .max(
                    10,
                    "Mobile Number must not be greater than 10 characters"
                  ),
                mobile_no2: Yup.string()
                  .max(
                    10,
                    "Mobile Number must not be greater than 10 characters"
                  )
                  .nullable(),
                nic: Yup.string().min(10, "NIC must not be less than 10 characters").max(12, "NIC must not be greater than 12 characters").required("NIC is required."),
                place_of_birth: Yup.string().required("Place of birth is required."),
                marital_status: Yup.string().required("Marital Status is required."),
                home_no1: Yup.string()
                  .max(10, "Home Number must not be greater than 15 characters")
                  .nullable(),
                email_address: Yup.string()
                  .email("Invalid email format")
                  .max(
                    100,
                    "Email Address must not be greater than 100 characters"
                  )
                  .nullable(),
                passport_no: Yup.string().when("no_passport", {
                  is: (val: any) => !val,
                  then: Yup.string().required("Passport number is required."),
                  otherwise: Yup.string().nullable(),
                }),
                passport_date_of_issue: Yup.date().when("no_passport", {
                  is: (val: any) => !val,
                  then: Yup.date()
                    .required("Date of Issue is Required")
                    .max(
                      new Date(),
                      "Date of Issue must be before or on the current date"
                    ),
                  otherwise: Yup.date().nullable(),
                }),
                passport_place_of_issue: Yup.string().when("no_passport", {
                  is: (val: any) => !val,
                  then: Yup.string().required("Passport issue place is required"),
                  otherwise: Yup.string().nullable(),
                }),
                passport_expire_date: Yup.date().when("no_passport", {
                  is: (val: any) => !val,
                  then: Yup.date()
                    .required("Expiration Date is required")
                    .min(new Date(), "Passport has expired"),
                  otherwise: Yup.date().nullable(),
                }),
                // languages: Yup.string()
                //   .required("Languages are Required")
                //   .max(55, "Languages must not be greater than 55 characters"),
                gender: Yup.string().required("Gender is Required"),
                address: Yup.string()
                  .max(125, "Address must not be greater than 125 character")
                  .nullable(),
                remark: Yup.string()
                  .max(500, "Remark must not be greater than 500 character")
                  .nullable(),
                children: Yup.array().nullable().of(
                  Yup.object().shape({
                    name: Yup.string()
                      .required("Child's name is required")
                      .min(2, "Child's name must be at least 2 characters")
                      .max(50, "Child's name must not be greater than 50 characters"),
                    dob: Yup.date()
                      .required("Child's date of birth is required")
                      .min(new Date("1900-01-01"), "Child's date of birth cannot be before 1900"),
                    gender: Yup.string()
                      .required("Child's gender is required")
                      .min(2, "Child's gender must be at least 2 characters"),
                  })
                ),
                district: Yup.string()
                  .required()
                  .max(25, "District should not be greater than 25 characters"),
                height: Yup.number().required("Height is required.").min(0, 'Height cannot be less than to zero'),
                height_unit: Yup.string().required("Height unit is required.").max(4, 'Height unit must not be greater than 3 characters'),
                weight: Yup.number().required("Weight is required.").min(0, 'Weight cannot be zero'),
                guardian_name: Yup.string().required("Guardian's name is required").min(2, "Guardian's name must be at least 2 characters").max(50, "Guardian's name must not be greater than 50 characters"),
                guardian_relationship: Yup.string().required("Guardian relationship is required").min(2, "Guardian relationship must be at least 2 characters").max(50, "Guardian relationship must not be greater than 50 characters"),
                guardian_dob: Yup.date().required("Guardian's date of birth is required").min(new Date("1900-01-01"), "Guardian's date of birth cannot be before 1900"),
                guardian_nic: Yup.string().nullable().max(12, "Guardian's NIC must not be greater than 12 characters"),
                guardian_address: Yup.string().nullable().max(125, "Guardian's address must not be greater than 125 characters"),
                guardian_contact1: Yup.string().required("Guardian's contact is required").min(2, "Guardian's contact must be at least 2 characters").max(50, "Guardian's contact must not be greater than 50 characters"),
                grama_dvs: Yup.string().required("Grama Niladari is required").min(2, "Grama Niladari must be at least 2 characters").max(50, "Grama Niladari must not be greater than 50 characters"),
                grama_division: Yup.string().required("Grama Division is required").min(2, "Grama Division must be at least 2 characters").max(50, "Grama Division must not be greater than 50 characters"),
                salary_currency: Yup.string().nullable().min(2, "Currency must be at least 3 characters").max(3, "Currency must be exactly 3 characters"),
                note: Yup.string().nullable().max(500, "Salary note must not be greater than 500 characters")
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createResume
                  : editResume
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                validateForm,
                setFieldValue,
                setFieldTouched,
                setFieldError,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-rows ">
                  <Card className="p-3 border">
                    <Typography variant="h2" fontSize={18} className="mb-2">Personal Information </Typography>
                    <div className="grid grid-cols-3 mt-4 mb-2">
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <ThemeProvider theme={theme}>
                          <TextField
                            disabled={props.dialogAction == EDialogAction.view}
                            id="first_name"
                            label="First Name"
                            variant="outlined"
                            required
                            onChange={(e) => {
                              const pattern = /^[A-Za-z\s]*$/;
                              if (pattern.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            value={values.first_name || ""}
                            placeholder="Enter First Name"
                            name="first_name"
                            InputProps={{
                              classes: {
                                disabled: classes.disabled,
                              },
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            error={Boolean(
                              errors.first_name && touched.first_name
                            )}
                            helperText={
                              errors.first_name && touched.first_name &&
                              String(errors.first_name)
                            }
                          />
                        </ThemeProvider>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="last_name"
                          label="Last Name"
                          variant="outlined"
                          required
                          onChange={(e) => {
                            const pattern = /^[A-Za-z\s]*$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.last_name || ""}
                          placeholder="Enter Last Name"
                          name="last_name"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.last_name && touched.last_name)}
                          helperText={
                            errors.last_name &&
                            touched.last_name &&
                            String(errors.last_name)
                          }
                        />
                      </div>

                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="other_name"
                          label="Other Name"
                          variant="outlined"
                          onChange={(e) => {
                            const pattern = /^[A-Za-z]*$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.other_name || ""}
                          placeholder="Enter Other Name"
                          name="other_name"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.other_name && touched.other_name
                          )}
                          helperText={
                            errors.other_name &&
                            touched.other_name &&
                            String(errors.other_name)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="nic"
                          label="NIC"
                          variant="outlined"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 12) {
                              handleChange(e);
                            }
                          }}
                          value={values.nic || ""}
                          placeholder="Enter NIC"
                          required
                          name="nic"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.nic && touched.nic)}
                          helperText={
                            errors.nic && touched.nic && String(errors.nic)
                          }
                        />
                      </div>


                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="place_of_birth"
                          label="Place of Birth"
                          variant="outlined"
                          onChange={(e) => {
                            const pattern = /^[A-Za-z\s]*$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.place_of_birth || ""}
                          placeholder="Enter Place of Birth"
                          required
                          name="place_of_birth"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.place_of_birth && touched.place_of_birth
                          )}
                          helperText={
                            errors.place_of_birth &&
                            touched.place_of_birth &&
                            String(errors.place_of_birth)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <CustomDatePicker
                          name="birth_of_date"
                          label="Date of Birth"
                          isRequired={true}
                          maxDate={new Date()}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <FormControl>
                          <InputLabel id="marital_status-label" required>
                            Marital Status
                          </InputLabel>
                          <Select
                            disabled={props.dialogAction == EDialogAction.view}
                            style={{ width: 250, fontSize: 14 }}
                            id="marital_status"
                            defaultValue="single"
                            label="Marital Status"
                            labelId="marital_status-label"
                            value={values.marital_status || ""}
                            required
                            placeholder={
                              values == ""
                                ? "Enter Marital Status"
                                : resume.marital_status
                            }
                            onChange={handleChange}
                            name="marital_status"
                            error={Boolean(
                              touched.marital_status && errors.marital_status
                            )}
                          >                            
                            <MenuItem value={"single"}>Single</MenuItem>
                            <MenuItem value={"married"}>Married</MenuItem>
                            <MenuItem value={"divorced"}>Divorced</MenuItem>
                          </Select>
                        </FormControl>
                        <FormHelperText style={{ color: "red" }}>
                          {errors.marital_status &&
                            touched.marital_status &&
                            String(errors.marital_status)}
                        </FormHelperText>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          type="number"
                          disabled={props.dialogAction == EDialogAction.view}
                          id="number_of_children"
                          variant="outlined"
                          onChange={(e) => {
                            const count = parseInt(e.target.value);
                            if (!count || count > 0) {
                              if (count > 0 && props.dialogAction == EDialogAction.create) {
                                setFieldValue(
                                  "children",
                                  count > 0 ? Array(count).fill({ name: '', dob: '', gender: '' }) : []
                                );
                              }
                              handleChange(e);
                            }
                          }}
                          value={values.number_of_children || ""}
                          placeholder="Enter Number of Children"
                          name="number_of_children"
                          label="Number of Children"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.number_of_children &&
                            touched.number_of_children
                          )}
                          helperText={
                            errors.number_of_children &&
                            touched.number_of_children &&
                            String(errors.number_of_children)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <FormControl>
                          <InputLabel id="qua-label">Qualification</InputLabel>
                          <Select
                            disabled={props.dialogAction == EDialogAction.view}
                            style={{ width: 250, fontSize: 14 }}
                            id="qua"
                            defaultValue="O"
                            value={values.qua || ""}
                            onChange={handleChange}
                            name="qua"
                            label="Qualification"
                            labelId="qua-label"
                            error={Boolean(touched.qua && errors.qua)}
                          >
                            <MenuItem value={""}>
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={"Grade 5"}>Grade 5</MenuItem>
                            <MenuItem value={"Grade 8"}>Grade 8</MenuItem>
                            <MenuItem value={"GCE O/L"}>GCE O/L</MenuItem>
                            <MenuItem value={"GCE A/L"}>GCE A/L</MenuItem>
                            <MenuItem value={"Diploma"}>Diploma</MenuItem>
                            <MenuItem value={"Bachelor of degree"}>Bachelor of degree</MenuItem>
                          </Select>
                        </FormControl>
                        <FormHelperText style={{ color: "red" }}>
                          {errors.qua && touched.qua && String(errors.qua)}
                        </FormHelperText>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <div>
                          <FormControl>
                            <InputLabel id="gender-label" required>Gender</InputLabel>
                            <Select
                              labelId="gender-label"
                              label="Gender"
                              disabled={
                                props.dialogAction == EDialogAction.view
                              }
                              style={{ width: 250, fontSize: 14 }}
                              id="gender"
                              defaultValue="M"
                              value={values.gender || ""}
                              onChange={handleChange}
                              name="gender"
                              required
                              error={Boolean(touched.gender && errors.gender)}
                            >
                              <MenuItem value={"M"}>Male</MenuItem>
                              <MenuItem value={"F"}>Female</MenuItem>
                            </Select>
                          </FormControl>
                          <FormHelperText style={{ color: "red" }}>
                            {errors.gender &&
                              touched.gender &&
                              String(errors.gender)}
                          </FormHelperText>
                        </div>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">

                        <FormControl>
                          <InputLabel id="religion-label" required>Religion</InputLabel>
                          <Select
                            disabled={props.dialogAction == EDialogAction.view}
                            style={{ width: 250, fontSize: 14 }}
                            id="religion"
                            label="Religion"
                            labelId="religion-label"
                            defaultValue="muslim"
                            value={values.religion || ""}
                            onChange={handleChange}
                            name="religion"
                            required
                            error={Boolean(touched.religion && errors.religion)}
                          >
                            <MenuItem value={"buddhist"}>Buddhism</MenuItem>
                            <MenuItem value={"christian"}>Christian</MenuItem>
                            <MenuItem value={"muslim"}>Muslim</MenuItem>
                            <MenuItem value={"non-muslim"}>Non Muslim</MenuItem>
                            <MenuItem value={"hindu"}>Hindu</MenuItem>
                          </Select>
                        </FormControl>
                        <FormHelperText style={{ color: "red" }}>
                          {errors.religion &&
                            touched.religion &&
                            String(errors.religion)}
                        </FormHelperText>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <FormControl>
                          <InputLabel id="look-label" required>Complexion</InputLabel>
                          <Select
                            disabled={props.dialogAction == EDialogAction.view}
                            style={{ width: 250, fontSize: 14 }}
                            id="look"
                            label="Complexion"
                            labelId="look-label"
                            required
                            defaultValue="fair"
                            value={values.look || ""}
                            onChange={handleChange}
                            name="look"
                            error={Boolean(touched.look && errors.look)}
                          >
                            <MenuItem value={"fair"}>Fair</MenuItem>
                            <MenuItem value={"dark"}>Dark</MenuItem>
                          </Select>
                        </FormControl>
                        <FormHelperText style={{ color: "red" }}>
                          {errors.look && touched.look && String(errors.look)}
                        </FormHelperText>
                      </div>
                      <div className="flex flex-row space-x-2">
                        <div className="flex flex-col space-y-1 mb-4">
                          {values.height_unit === "inch" && (
                            <TextField
                              disabled={props.dialogAction == EDialogAction.view}
                              id="foot"
                              variant="outlined"
                              onChange={handleChange}
                              value={values.foot || ""}
                              placeholder="Enter the Foot"
                              required
                              type={"number"}
                              name="foot"
                              label="Foot"
                              InputProps={{
                                classes: {
                                  disabled: classes.disabled,
                                },
                                style: {
                                  fontSize: "14px",
                                },
                              }}
                              error={Boolean(errors.foot && touched.foot)}
                              helperText={
                                errors.foot &&
                                touched.foot &&
                                String(errors.foot)
                              }
                            />
                          )}
                        </div>
                        <div className="flex flex-col space-y-1 mb-4">
                          <TextField
                            disabled={props.dialogAction == EDialogAction.view}
                            id="height"
                            variant="outlined"
                            onChange={handleChange}
                            value={values.height || "0"}
                            placeholder="Enter the Height"
                            required
                            type={"number"}
                            name="height"
                            label={values.height_unit === "inch" ? "Inch" : "Height"}
                            InputProps={{
                              classes: {
                                disabled: classes.disabled,
                              },
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            error={Boolean(errors.height && touched.height)}
                            helperText={
                              errors.height &&
                              touched.height &&
                              String(errors.height)
                            }
                          />
                        </div>
                        <div className="flex flex-col space-y-1 mb-4">
                          <FormControl>
                            <InputLabel id="height-unit-label" required>
                              Unit
                            </InputLabel>
                            <Select
                              disabled={props.dialogAction == EDialogAction.view}
                              style={{ width: "auto", fontSize: 14 }}
                              className="mr-2"
                              id="height_unit"
                              label="Height Unit"
                              labelId="height-unit-label"
                              defaultValue="cm"
                              value={values.height_unit || ""}
                              onChange={handleChange}
                              name="height_unit"
                              required
                              error={Boolean(
                                touched.height_unit && errors.height_unit
                              )}
                            >
                              <MenuItem value={"cm"}>cm</MenuItem>
                              <MenuItem value={"inch"}>foot & inch</MenuItem>
                            </Select>
                          </FormControl>
                          <FormHelperText style={{ color: "red" }}>
                            {errors.height_unit &&
                              touched.height_unit &&
                              String(errors.height_unit)}
                          </FormHelperText>
                        </div>
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="weight"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.weight || ""}
                          placeholder="Enter the Weight"
                          required
                          type={"number"}
                          name="weight"
                          label="Weight (kg)"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.weight && touched.weight)}
                          helperText={
                            errors.weight &&
                            touched.weight &&
                            String(errors.weight)
                          }
                        />
                      </div>
                    </div>
                  </Card>
                  <Divider className="my-3" />
                  <Card className="p-3 border">
                    <Typography variant="h2" fontSize={18} className="mb-2">Contact Details</Typography>
                    <div className="grid grid-cols-3 mt-4 mb-2">
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="mobile_no1"
                          variant="outlined"
                          onChange={(e) => {
                            const pattern = /^[0-9]{0,10}$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.mobile_no1 || ""}
                          placeholder="Example : 0779998800"
                          required
                          name="mobile_no1"
                          label="Mobile Number"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.mobile_no1 && touched.mobile_no1
                          )}
                          helperText={
                            errors.mobile_no1 &&
                            touched.mobile_no1 &&
                            String(errors.mobile_no1)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="mobile_no2"
                          variant="outlined"
                          onChange={(e) => {
                            const pattern = /^[0-9]{0,10}$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.mobile_no2 || ""}
                          placeholder="Example : 0779998800"
                          label="Whatsapp Number"
                          name="mobile_no2"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.mobile_no2 && touched.mobile_no2
                          )}
                          helperText={
                            errors.mobile_no2 &&
                            touched.mobile_no2 &&
                            String(errors.mobile_no2)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="home_no1"
                          variant="outlined"
                          onChange={(e) => {
                            const pattern = /^[0-9]{0,10}$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          value={values.home_no1 || ""}
                          placeholder="Enter Home Number"
                          label="Home Number"
                          name="home_no1"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.home_no1 && touched.home_no1)}
                          helperText={
                            errors.home_no1 &&
                            touched.home_no1 &&
                            String(errors.home_no1)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="email_address"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.email_address || ""}
                          placeholder="Enter Email Address"
                          label="Email Address"
                          type={"email"}
                          name="email_address"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.email_address && touched.email_address
                          )}
                          helperText={
                            errors.email_address &&
                            touched.email_address &&
                            String(errors.email_address)
                          }
                        />
                      </div>
                      <div className="flex flex-col col-span-2 space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="address"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.address || ""}
                          placeholder="Enter Address"
                          label="Address"
                          name="address"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.address && touched.address)}
                          helperText={
                            errors.address &&
                            touched.address &&
                            String(errors.address)
                          }
                        />
                      </div>
                      {/*  <div className="flex flex-col space-y-1 mr-6 mb-4">
                      <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="district"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.district || ""}
                          placeholder="Enter District"
                          label="District"
                          name="district"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.district && touched.district)}
                          helperText={
                            errors.district &&
                            touched.district &&
                            String(errors.district)
                          }
                        /> 
                        <FormControl>
                          <InputLabel id="district-label" required>District</InputLabel>
                          <Select
                            disabled={props.dialogAction == EDialogAction.view}
                            style={{ width: 'auto', fontSize: 14 }}
                            id="district"
                            label="District"
                            labelId="district-label"
                            value={values.district || ""}
                            onChange={handleChange}
                            name="district"
                            required
                            error={Boolean(touched.district && errors.district)}
                          >
                            <MenuItem value={"Ampara"}>Ampara</MenuItem>
                            <MenuItem value={"Anuradhapura"}>Anuradhapura</MenuItem>
                            <MenuItem value={"Badulla"}>Badulla</MenuItem>
                            <MenuItem value={"Batticaloa"}>Batticaloa</MenuItem>
                            <MenuItem value={"Colombo"}>Colombo</MenuItem>
                            <MenuItem value={"Galle"}>Galle</MenuItem>
                            <MenuItem value={"Gampaha"}>Gampaha</MenuItem>
                            <MenuItem value={"Hambantota"}>Hambantota</MenuItem>
                            <MenuItem value={"Jaffna"}>Jaffna</MenuItem>
                            <MenuItem value={"Kalutara"}>Kalutara</MenuItem>
                            <MenuItem value={"Kandy"}>Kandy</MenuItem>
                            <MenuItem value={"Kegalle"}>Kegalle</MenuItem>
                            <MenuItem value={"Kilinochchi"}>Kilinochchi</MenuItem>
                            <MenuItem value={"Kurunegala"}>Kurunegala</MenuItem>
                            <MenuItem value={"Mannar"}>Mannar</MenuItem>
                            <MenuItem value={"Matale"}>Matale</MenuItem>
                            <MenuItem value={"Matara"}>Matara</MenuItem>
                            <MenuItem value={"Monaragala"}>Monaragala</MenuItem>
                            <MenuItem value={"Mullaitivu"}>Mullaitivu</MenuItem>
                            <MenuItem value={"Nuwara Eliya"}>Nuwara Eliya</MenuItem>
                            <MenuItem value={"Polonnaruwa"}>Polonnaruwa</MenuItem>
                            <MenuItem value={"Puttalam"}>Puttalam</MenuItem>
                            <MenuItem value={"Ratnapura"}>Ratnapura</MenuItem>
                            <MenuItem value={"Trincomalee"}>Trincomalee</MenuItem>
                            <MenuItem value={"Vavuniya"}>Vavuniya</MenuItem>
                          </Select>
                        </FormControl>
                        <FormHelperText style={{ color: "red" }}>
                          {errors.district &&
                            touched.district &&
                            String(errors.district)}
                        </FormHelperText>
                      </div>
                      */}
                    </div>
                  </Card>
                  {!resume?.rec_status && (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border">
                        <div className="flex items-center justify-between">
                          <Typography variant="h2" fontSize={18} className="mb-2">Passport Details</Typography>
                          <FormControl>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.no_passport}
                                  onChange={(e) => {
                                    setFieldValue("no_passport", e.target.checked);
                                  }}
                                  value={values.no_passport}
                                  name="no_passport"
                                />
                              }
                              label="No Passport"
                            />
                          </FormControl>
                        </div>
                        {!values.no_passport && (
                          <div className="grid grid-cols-3 mt-4 mb-2">
                            <div className="flex flex-col space-y-1 mr-6 mb-4">
                              <TextField
                                disabled={props.dialogAction == EDialogAction.view}
                                id="passport_no"
                                variant="outlined"
                                onChange={handleChange}
                                value={values.passport_no || ""}
                                placeholder="Enter Passport Number"
                                label="Passport Number"
                                name="passport_no"
                                required
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                error={Boolean(
                                  errors.passport_no && touched.passport_no
                                )}
                                helperText={
                                  errors.passport_no &&
                                  touched.passport_no &&
                                  String(errors.passport_no)
                                }
                              />
                            </div>
                            <div className="flex flex-col space-y-1 mr-6 mb-4">
                              <TextField
                                disabled={props.dialogAction == EDialogAction.view}
                                id="passport_place_of_issue"
                                variant="outlined"
                                onChange={handleChange}
                                value={values.passport_place_of_issue || ""}
                                placeholder="Enter Place of Issue"
                                label="Place of Issue"
                                required
                                name="passport_place_of_issue"
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                error={Boolean(
                                  errors.passport_place_of_issue &&
                                  touched.passport_place_of_issue
                                )}
                                helperText={
                                  errors.passport_place_of_issue &&
                                  touched.passport_place_of_issue &&
                                  String(errors.passport_place_of_issue)
                                }
                              />
                            </div>

                            <div className="flex flex-col space-y-1 mr-6 mb-4">
                              <CustomDatePicker
                                name="passport_date_of_issue"
                                label="Date of Issue"
                                isRequired={true}
                                maxDate={new Date()}
                                onUpdate={(field: any, value: any) => {
                                  setFieldValue('passport_date_of_issue', value || "");
                                  const expireDate = new Date(value);
                                  expireDate.setFullYear(expireDate.getFullYear() + 10);
                                  values.passport_expire_date = expireDate.toISOString().split("T")[0];
                                }}
                              />
                              {/* <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="passport_date_of_issue"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.passport_date_of_issue || ""}
                          placeholder="Enter Date of Issue"
                          
                          name="passport_date_of_issue"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                            
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.passport_date_of_issue &&
                              touched.passport_date_of_issue
                          )}
                          helperText={
                            errors.passport_date_of_issue &&
                              touched.passport_date_of_issue &&
                              String(errors.passport_date_of_issue)
                          }
                        /> */}
                            </div>

                            <div className="flex flex-col space-y-1 mr-6 mb-4">
                              <CustomDatePicker
                                name="passport_expire_date"
                                label="Expire Date"
                                isRequired={true}
                                onUpdate={(field: any, value: any) => {
                                  setFieldValue('passport_expire_date', value || "");
                                }}
                              />

                              {/* <TextField
                          disabled={props.dialogAction == EDialogAction.view}
                          id="passport_expire_date"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.passport_expire_date || ""}
                          placeholder="Enter Expiration Date"
                          
                          name="passport_expire_date"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                            
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.passport_expire_date &&
                              touched.passport_expire_date
                          )}
                          helperText={
                            errors.passport_expire_date &&
                              touched.passport_expire_date &&
                              String(errors.passport_expire_date)
                          }
                        /> */}
                            </div>
                          </div>
                        )}
                      </Card>
                    </>
                  )}
                  {values.number_of_children > 0 && values.children && (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border mb-3 ">
                        <div className="flex items-center justify-between">
                          <Typography variant="h2" fontSize={18} className="mb-2 col-span-1">Children Details</Typography>
                          {props.dialogAction !== EDialogAction.create && (
                            <div className="flex justify-end col-span-1 gap-2">
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setFieldValue('children', [...values.children, { name: '', dob: '', gender: '' }])}
                                className="w-1/4"
                              >
                                Add
                              </Button>
                            </div>
                          )}
                        </div>
                        <div className="grid grid-cols-4 gap-1">
                          {values.children.map((child: IChild, index: number) => (
                            <Card key={index} className="p-3 border mb-3">
                              <div className="flex items-center justify-between">
                                <Typography variant="h3" fontSize={16} className="mb-2">Child {index + 1}</Typography>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    if (props.dialogAction !== EDialogAction.create) {
                                      setFieldValue(
                                        'children',
                                        values.children.filter((child: any, childIndex: number) => childIndex !== index)
                                      );
                                    }
                                  }}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              </div>
                              <div className="flex flex-col space-y-3 mt-4">
                                {/* Child Name */}
                                <TextField
                                  disabled={props.dialogAction === EDialogAction.view}
                                  id={`children.${index}.name`}
                                  label="Name"
                                  variant="outlined"
                                  onChange={handleChange}
                                  value={child.name || ""}
                                  placeholder="Enter Child Name"
                                  name={`children[${index}].name`}
                                  required
                                  InputProps={{
                                    classes: {
                                      disabled: classes.disabled,
                                    },
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  error={Boolean((errors.children as any)?.[index]?.name || (touched.children as any)?.[index]?.name)}
                                  helperText={(errors.children as any)?.[index]?.name && String((errors.children as any)[index].name)}
                                />

                                {/* Child Date of Birth */}
                                <TextField
                                  disabled={props.dialogAction === EDialogAction.view}
                                  id={`children.${index}.dob`}
                                  label="Date of Birth"
                                  variant="outlined"
                                  onChange={handleChange}
                                  value={child.dob || ""}
                                  name={`children[${index}].dob`}
                                  type="date"
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{ max: new Date().toISOString().split('T')[0] }}
                                  required
                                  InputProps={{
                                    classes: {
                                      disabled: classes.disabled,
                                    },
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  error={Boolean((errors.children as any)?.[index]?.dob || (touched.children as any)?.[index]?.dob)}
                                  helperText={(errors.children as any)?.[index]?.dob && String((errors.children as any)[index].dob)}
                                />

                                {/* Child Gender */}
                                <Autocomplete
                                  disablePortal
                                  options={[
                                    { title: 'Male' },
                                    { title: 'Female' },
                                    { title: 'Other' },
                                  ]}
                                  getOptionLabel={(option) => option.title || ''}
                                  isOptionEqualToValue={(option, value) => option.title === value.title}
                                  onChange={(e, value) => setFieldValue(`children[${index}].gender`, value ? value.title : "")}
                                  value={child.gender ? { title: child.gender } : null}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Select Gender"
                                      variant="outlined"
                                      required
                                      error={Boolean((errors.children as any)?.[index]?.gender || (touched.children as any)?.[index]?.gender)}
                                      helperText={(errors.children as any)?.[index]?.gender && String((errors.children as any)[index].gender)}
                                    />
                                  )}
                                />
                              </div>
                            </Card>
                          ))}
                        </div>
                      </Card>
                    </>
                  )}
                  <Divider className="my-3" />
                  <Card className="p-3 border">
                    <Typography variant="h2" fontSize={18} className="mb-2">Guardian Details</Typography>
                    <div className="grid grid-cols-3 mt-4">
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          label="Guardian Name"
                          value={values.guardian_name || ''}
                          onChange={(e) => {
                            const pattern = /^[A-Za-z\s]*$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          fullWidth
                          name="guardian_name"
                          required
                          error={Boolean(errors.guardian_name && touched.guardian_name)}
                          helperText={touched.guardian_name && errors.guardian_name ? String(errors.guardian_name) : ""}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          freeSolo
                          autoSelect
                          options={["Father", "Mother", "Son", "Daughter", "Spouse", "Sibling", "Relative", "Boy friend"]}
                          value={values.guardian_relationship || ''}
                          onChange={(e, value: any) => setFieldValue('guardian_relationship', value || "")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Relationship"
                              variant="outlined"
                              fullWidth
                              name="guardian_relationship"
                              required
                              error={Boolean(errors.guardian_relationship && touched.guardian_relationship)}
                              helperText={touched.guardian_relationship && errors.guardian_relationship ? String(errors.guardian_relationship) : ""}
                            />
                          )}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          label="Date of Birth"
                          value={values.guardian_dob || ''}
                          onChange={handleChange}
                          fullWidth
                          name="guardian_dob"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ max: new Date().toISOString().split('T')[0] }}
                          required
                          error={Boolean(errors.guardian_dob && touched.guardian_dob)}
                          helperText={touched.guardian_dob && errors.guardian_dob ? String(errors.guardian_dob) : ""}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          label="NIC"
                          value={values.guardian_nic || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 12) {
                              handleChange(e);
                            }
                          }}
                          fullWidth
                          name="guardian_nic"
                          error={Boolean(errors.guardian_nic && touched.guardian_nic)}
                          helperText={touched.guardian_nic && errors.guardian_nic ? String(errors.guardian_nic) : ""}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 md:col-start-2 md:col-span-2 mr-6 mb-4">
                        <TextField
                          label="Address"
                          value={values.guardian_address || ''}
                          onChange={handleChange}
                          fullWidth
                          name="guardian_address"
                          multiline
                          error={Boolean(errors.guardian_address && touched.guardian_address)}
                          helperText={touched.guardian_address && errors.guardian_address ? String(errors.guardian_address) : ""}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          label="Contact 1"
                          value={values.guardian_contact1 || ''}
                          onChange={(e) => {
                            const pattern = /^[0-9]{0,10}$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          fullWidth
                          name="guardian_contact1"
                          required
                          error={Boolean(errors.guardian_contact1 && touched.guardian_contact1)}
                          helperText={touched.guardian_contact1 && errors.guardian_contact1 ? String(errors.guardian_contact1) : ""}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          label="Contact 2"
                          value={values.guardian_contact2 || ''}
                          onChange={(e) => {
                            const pattern = /^[0-9]{0,10}$/;
                            if (pattern.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          fullWidth
                          name="guardian_contact2"
                        />
                      </div>
                    </div>
                  </Card>
                  <Divider className="my-3" />
                  <Card className="p-3 border">
                    <Typography variant="h2" fontSize={18} className="mb-2">Gramaniladari Information</Typography>
                    <div className="grid grid-cols-3 mt-4">
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          options={districts.map((option) => option)}
                          value={values.district || ''}
                          onChange={(event, value) => {
                            setFieldValue('district', value || '');
                            setFieldValue('grama_dvs', '');
                            setFieldValue('grama_division', '');
                            fetchDVS(value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="District"
                              variant="outlined"
                              fullWidth
                              name="district"
                              required
                              error={Boolean(errors.district && touched.district)}
                              helperText={touched.district && errors.district ? String(errors.district) : ""}
                            />
                          )}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          options={dvsOptions.map((option) => option)}
                          value={values.grama_dvs || ''}
                          onChange={(event, value) => {
                            setFieldValue('grama_dvs', value || '');
                            setFieldValue('grama_division', '');
                            fetchDivision(value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Divisional Secretariat"
                              variant="outlined"
                              fullWidth
                              name="grama_dvs"
                              required
                              error={Boolean(errors.grama_dvs && touched.grama_dvs)}
                              helperText={touched.grama_dvs && errors.grama_dvs ? String(errors.grama_dvs) : ""}
                            />
                          )}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          freeSolo
                          disablePortal
                          options={divisionOptions.map((option) => option)}
                          value={values.grama_division || ''}
                          onChange={(event, value) => setFieldValue('grama_division', value || '')}
                          onInputChange={(event, value) => {
                            if (event && event.type === 'change') {
                              setFieldValue('grama_division', value || '');
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Grama Division"
                              variant="outlined"
                              fullWidth
                              name="grama_division"
                              required
                              error={Boolean(errors.grama_division && touched.grama_division)}
                              helperText={touched.grama_division && errors.grama_division ? String(errors.grama_division) : ""}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Card>
                  <Divider className="my-3" />
                  <Card className="p-3 border">
                    <Typography variant="h2" fontSize={18} className="mb-2">Other Details</Typography>
                    <div className="grid grid-cols-3 mt-4">
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          multiple
                          options={["TV", "Radio", "Facebook", "Youtube", "Tiktok", "Instagram", "WhatsApp", "From a friend"]}
                          value={values.vacancy_source ? JSON.parse(values.vacancy_source) : []}
                          onChange={(e, value: any) => setFieldValue('vacancy_source', JSON.stringify(value))}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Source of Vacancy"
                              variant="outlined"
                              fullWidth
                              name="vacancy_source"
                            />
                          )}
                        />
                      </div>
                      {/*
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={jobTitleListForOther}
                          getOptionLabel={(option) => option.title}
                          isOptionEqualToValue={(option, value) => option.id === value.id} // Custom equality check
                          onChange={(e, value) => setFieldValue("base_job_title", value ? value.title : "")}
                          onOpen={() => handleJobListChange(" ", 'jobTitleOther')} // Handle open event
                          onInputChange={(event, value) => handleJobListChange(value, 'jobTitleOther')} // Handle input change event
                          value={jobTitleListForOther.find(job => job.title === values.base_job_title) || null}
                          sx={{
                            "& .MuiInputBase-root": {
                              fontSize: "14px",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="base_job_title"
                              required
                              key={params.inputProps.id} // Ensure unique key
                              placeholder={values.base_job_title?.title ?? "Select"}
                              label="Job Title"
                              error={Boolean(touched.base_job_title && errors.base_job_title)}
                              helperText={touched.base_job_title && errors.base_job_title ? String(errors.base_job_title) : ""}
                            />
                          )}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction === EDialogAction.view}
                          id="languages"
                          required
                          variant="outlined"
                          onChange={handleChange}
                          value={values.languages || ""}
                          placeholder="Enter Languages"
                          label="Languages"
                          name="languages"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.languages && touched.languages)}
                          helperText={
                            errors.languages &&
                            touched.languages &&
                            String(errors.languages)
                          }
                        />
                        </div>*/}
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          freeSolo
                          disablePortal
                          id="combo-box-demo"
                          sx={{
                            "& .MuiInputBase-root": {
                              fontSize: "14px",
                            },
                          }}
                          options={subAgentList}
                          value={subAgentList.find(agent => agent.id == values.sub_agent_id) || null}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, value) => {
                            if (typeof value === 'string') {
                              setFieldValue("sub_agent_id", value);
                            } else {
                              setFieldValue("sub_agent_id", value ? value.id : "");
                            }
                          }}
                          onInputChange={(e, newInputValue) => {
                            setFieldValue("sub_agent_id", newInputValue);
                          }}
                          style={{ width: 245, fontSize: 14 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="sub_agent_id"
                              label="Sub-Agent Id"
                              placeholder={
                                values === ""
                                  ? "Enter Sub-Agent Id"
                                  : subAgent.name
                              }
                              error={Boolean(
                                touched.sub_agent_id && errors.sub_agent_id
                              )}
                              helperText={
                                errors.sub_agent_id &&
                                touched.sub_agent_id &&
                                String(errors.sub_agent_id)
                              }
                            />
                          )}
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          sx={{
                            "& .MuiInputBase-root": {
                              fontSize: "14px",
                            },
                          }}
                          options={staffList}
                          value={staffList.find(staff => staff.id == values.staff_id) || null}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, value) =>
                            setFieldValue("staff_id", value ? value.id : "")
                          }
                          style={{ width: 245, fontSize: 14 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="staff_id"
                              label="Calling Staff"
                              value={values.staff_id || ""}
                              placeholder={
                                values === ""
                                  ? "Enter Staff Id"
                                  : staffList.find(staff => staff.id == values.staff_id)?.name
                              }
                              error={Boolean(
                                touched.staff_id && errors.staff_id
                              )}
                              helperText={
                                errors.staff_id &&
                                touched.staff_id &&
                                String(errors.staff_id)
                              }
                            />
                          )}
                        />
                      </div>
                      {/*
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction === EDialogAction.view}
                          id="month_salary"
                          label="Monthly Salary"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.month_salary || ""}
                          placeholder="Enter Monthly Salary"
                          name="month_salary"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(
                            errors.month_salary && touched.month_salary
                          )}
                          helperText={
                            errors.month_salary &&
                            touched.month_salary &&
                            String(errors.month_salary)
                          }
                        />
                      </div>
                      <div className="flex flex-col space-y-1 mr-6 mb-4">
                        <TextField
                          disabled={props.dialogAction === EDialogAction.view}
                          id="remark"
                          label="Remark"
                          multiline
                          variant="outlined"
                          onChange={handleChange}
                          value={values.remark || ""}
                          placeholder="Enter Remark"
                          name="remark"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.remark && touched.remark)}
                          helperText={
                            errors.remark &&
                            touched.remark &&
                            String(errors.remark)
                          }
                        />
                        </div> */}
                    </div>
                  </Card>
                  {(resume?.rec_status && resume?.rec_status !== "0" && props.dialogAction !== EDialogAction.create) ? (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border" aria-disabled={jobDataLoading}>
                        {/* <Typography variant="h2" fontSize={18}>Job List</Typography> */}
                        <Typography variant="h2" fontSize={18}>Experience Details</Typography>
                        <div className="grid grid-cols-3 mt-4">
                          <div className="flex space-x-2 justify-start mb-4">
                            <Autocomplete
                              disablePortal
                              disabled={jobDataLoading}
                              id="combo-box-demo"
                              options={jobTitleList}
                              getOptionLabel={(option) => option.title}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(e, value) => setJobId(value.id)}
                              onOpen={() => handleJobListChange(" ", 'jobList')} // Handle open event
                              onInputChange={(event, value) => handleJobListChange(value, 'jobList')} // Handle input change event
                              sx={{ width: 245, height: 30 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="job_id"
                                  disabled={jobDataLoading}
                                  key={params.inputProps.id} // Ensure unique key
                                  //onChange={handleChange}
                                  value={values.job_id || ""}
                                  label="Job Title"
                                  placeholder={
                                    values === ""
                                      ? "Enter the Job Title"
                                      : resume.base_job_title
                                  }
                                />
                              )}
                            />
                            {props.dialogAction === EDialogAction.edit ? (
                              <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                disabled={jobDataLoading}
                                onClick={() => {
                                  addJobs(resume.id);
                                }}
                              >
                                Add
                              </Button>
                            ) : null}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                          {jobList &&
                            jobList.map((data, index) => {
                              return (
                                <Card className="border" key={index}>
                                  {jobDataLoading && <LinearProgress />}
                                  <CardContent>
                                    <div className="flex justify-between">
                                      <Typography variant="h5" fontSize={18} component="div" className="mb-2">
                                        {data.job_title.title}
                                      </Typography>
                                      <Button
                                        onClick={() => deleteJobList(data.id)}
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={jobDataLoading}
                                      >
                                        <DeleteOutline />
                                      </Button>
                                    </div>
                                    <Divider className="my-2" />
                                    <Typography variant="h5" fontSize={14} component="div" className="mb-2">
                                      Experience
                                    </Typography>

                                    {experienceList
                                      .filter((e: any) => e.job_title_id === data.job_id)
                                      .map((e: any, key: number) => (
                                        <Chip
                                          key={key}
                                          label={`${e.note} - ${e.duration}Y${e.duration_months ? ` ${e.duration_months}M` : ""}`}
                                          className="m-1"
                                          color="primary"
                                          onDelete={() => deleteExperience(e.id)}
                                          disabled={jobDataLoading}
                                        />
                                      ))}

                                    <Card className="p-3 mt-2 border" elevation={0}>
                                      <div className="grid grid-cols-4 space-x-4">
                                        <div className="flex flex-col">
                                          <TextField
                                            disabled={
                                              props.dialogAction === EDialogAction.view || jobDataLoading
                                            }
                                            id={"duration_" + data.job_id}
                                            variant="outlined"
                                            size="small"
                                            onChange={handleChange}
                                            value={values["duration_" + data.job_id] || ""}
                                            placeholder="Enter Duration"
                                            label="(Years)"
                                            name={"duration_" + data.job_id}
                                            InputProps={{
                                              classes: {
                                                disabled: classes.disabled,
                                              },
                                              style: {
                                                fontSize: "14px",
                                              },
                                            }}
                                            error={Boolean(
                                              errors.duration && touched.duration
                                            )}
                                            helperText={
                                              errors.duration &&
                                              touched.duration &&
                                              String(errors.duration)
                                            }
                                          />
                                        </div>
                                        <div className="flex flex-col">
                                          <TextField
                                            disabled={
                                              props.dialogAction === EDialogAction.view || jobDataLoading
                                            }
                                            id={"duration_months_" + data.job_id}
                                            variant="outlined"
                                            size="small"
                                            onChange={handleChange}
                                            value={values["duration_months_" + data.job_id] || ""}
                                            placeholder="Months"
                                            label="(Months)"
                                            name={"duration_months_" + data.job_id}
                                            InputProps={{
                                              classes: {
                                                disabled: classes.disabled,
                                              },
                                              style: {
                                                fontSize: "14px",
                                              },
                                            }}
                                            error={Boolean(
                                              errors.duration_months && touched.duration_months
                                            )}
                                            helperText={
                                              errors.duration_months &&
                                              touched.duration_months &&
                                              String(errors.duration_months)
                                            }
                                          />
                                        </div>
                                        <div>
                                          <FormControl
                                            disabled={
                                              props.dialogAction === EDialogAction.view || jobDataLoading
                                            }
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                          >
                                            <InputLabel id="country-label">Country</InputLabel>
                                            <Select
                                              labelId="country-label"
                                              id="country"
                                              name={"noteEx_" + data.job_id}
                                              value={values["noteEx_" + data.job_id] || ""}
                                              onChange={handleChange}
                                              label="Country"
                                            >
                                              {Object.entries(CountryCodeEnum).map(([key, value]) => (
                                                <MenuItem key={key} value={value}>
                                                  {CountryCodeDisplayEnum[value]}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        </div>

                                        <div className=" ">
                                          {props.dialogAction === EDialogAction.edit ? (
                                            <Button
                                              color="primary"
                                              className="w-full"
                                              variant="contained"
                                              disabled={jobDataLoading}
                                              onClick={() => {
                                                addExperience(values["duration_" + data.job_id], values["noteEx_" + data.job_id], data.job_id, values["duration_months_" + data.job_id]);
                                              }}
                                            >
                                              Add
                                            </Button>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                    </Card>

                                    {/*<Divider className="my-2" />
                                    <Typography variant="h5" fontSize={16} component="div" className="mb-2">
                                      Skills
                                    </Typography>
                                    <List>
                                      {jobSkillList?.[data.job_title.id]?.map((skill: { skill: { skill_name: string; skill_id: number; description?: string }; skill_id: string, skill_level?: string }, index: number) => (
                                        <div key={index} className="flex justify-between items-center mb-2 border-b">
                                          <div>
                                            {skill.skill?.skill_name}
                                            <sup>
                                              <Tooltip title={skill.skill?.description}>
                                                <IconButton disableRipple><InfoRounded fontSize="small" color={skill.skill_level ? "action" : "info"} /></IconButton>
                                              </Tooltip>
                                            </sup>
                                          </div>
                                          <FormControl>
                                            <RadioGroup
                                              row
                                              value={data.skill_level}
                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                              name="skill_level"
                                              onChange={(event) => {
                                                let updatedJobSkillList = { ...jobSkillList };
                                                for (let jobTitleId in updatedJobSkillList) {
                                                  for (let sk of updatedJobSkillList[jobTitleId]) {
                                                    if (sk.skill_id === skill.skill_id) {
                                                      sk.skill_level = event.target.value;
                                                    }
                                                  }
                                                }

                                                setJobSkillList(updatedJobSkillList);
                                                createSkillLevel(skill.skill_id, event.target.value);
                                              }}
                                            >
                                              <FormControlLabel
                                                value="not_good"
                                                disabled={jobDataLoading}
                                                control={<Radio size="small" />}
                                                checked={skill.skill_level === 'not_good'}
                                                label="Not Good"
                                                labelPlacement="start"
                                                classes={{
                                                  label: classes.checkboxLabel,
                                                }}
                                              />
                                              <FormControlLabel
                                                value="good"
                                                disabled={jobDataLoading}
                                                control={<Radio size="small" />}
                                                checked={skill.skill_level === 'good'}
                                                label="Good"
                                                labelPlacement="start"
                                                classes={{
                                                  label: classes.checkboxLabel,
                                                }}
                                              />
                                              <FormControlLabel
                                                value="very_good"
                                                disabled={jobDataLoading}
                                                control={<Radio size="small" />}
                                                checked={skill.skill_level === 'very_good'}
                                                label="Very Good"
                                                labelPlacement="start"
                                                classes={{
                                                  label: classes.checkboxLabel,
                                                }}
                                              />
                                            </RadioGroup>
                                          </FormControl>
                                        </div>
                                      ))}
                                    </List> */}

                                  </CardContent>
                                </Card>
                              );
                            })}
                        </div>
                      </Card>
                    </>
                  ) : (
                    <div></div>
                  )}
                  {resume?.rec_status && resume?.rec_status !== "0" && (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border mb-3 ">
                        <div className="grid grid-cols-2 items-center mb-2 ">
                          <Typography variant="h2" fontSize={18} className="mb-2 col-span-1">Language Details</Typography>
                          <div className="flex justify-end col-span-1 gap-2">
                            <TextField
                              variant="outlined"
                              label="Enter Language Name"
                              value={newLanguageName}
                              onChange={(e) => setNewLanguageName(e.target.value)}
                              className="w-1/2"
                              size="small"
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                if (newLanguageName) {
                                  setFieldValue(
                                    'languages',
                                    (values.languages || []).concat({ name: newLanguageName, level: '' })
                                  );
                                  setNewLanguageName('');
                                }
                              }}
                              className="w-1/4"
                            >
                              Add
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => {
                                const defaultLanguages = ['English', 'Arabic'].filter(lang => !values.languages?.some((l: { name: string; }) => l.name === lang));
                                setFieldValue(
                                  'languages',
                                  (values.languages || []).concat(defaultLanguages.map(lang => ({ name: lang, level: '' })))
                                );
                              }}
                              className="w-1/4 mr-2"
                            >
                              Default
                            </Button>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-1">
                          {values.languages && values.languages.map((language: ILanguage, index: number) => (
                            <Card key={index} className="p-3 border mb-3">
                              <div className="flex items-center justify-between">
                                <Typography variant="h3" fontSize={16} className="mb-2">Language {index + 1}</Typography>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    if (props.dialogAction !== EDialogAction.create) {
                                      setFieldValue(
                                        'languages',
                                        values.languages.filter((lang: any, langIndex: number) => langIndex !== index)
                                      );
                                    }
                                  }}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              </div>

                              <div className="flex flex-col space-y-3 mt-4">
                                {/* Language Name */}
                                <TextField
                                  id={`languages.${index}.name`}
                                  label="Name"
                                  variant="outlined"
                                  value={language.name || ""}
                                  placeholder="Enter Language Name"
                                  name={`languages[${index}].name`}
                                  required
                                  InputProps={{
                                    classes: {
                                      disabled: classes.disabled,
                                    },
                                    style: {
                                      fontSize: "14px",
                                    },
                                    readOnly: true,
                                  }}
                                  error={Boolean((errors.languages as any)?.[index]?.name || (touched.languages as any)?.[index]?.name)}
                                  helperText={(errors.languages as any)?.[index]?.name && String((errors.languages as any)[index].name)}
                                />
                                {/* Language Level */}
                                <RadioGroup
                                  aria-label="language-level"
                                  name={`languages[${index}].level`}
                                  value={language.level || ""}
                                  onChange={handleChange}
                                  row
                                >
                                  <FormControlLabel
                                    value="Fair"
                                    control={<Radio disabled={props.dialogAction === EDialogAction.view} />}
                                    label="Fair"
                                  />
                                  <FormControlLabel
                                    value="Good"
                                    control={<Radio disabled={props.dialogAction === EDialogAction.view} />}
                                    label="Good"
                                  />
                                  <FormControlLabel
                                    value="Very Good"
                                    control={<Radio disabled={props.dialogAction === EDialogAction.view} />}
                                    label="Very Good"
                                  />
                                </RadioGroup>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </Card>
                    </>
                  )}
                  {(resume?.rec_status && resume?.rec_status !== "0" && props.dialogAction != EDialogAction.create) ? (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-4 border">
                        {/* <Typography variant="h6" gutterBottom>Salary Details</Typography> */}
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Agreed Commission"
                              name="agreed_commission"
                              type="number"
                              value={values.agreed_commission || ''}
                              onChange={handleChange}
                              InputProps={{ endAdornment: <InputAdornment position="end">LKR</InputAdornment> }}
                              fullWidth
                            />
                          </Grid>                          
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Monthly Salary"
                              name="month_salary"
                              type="number"
                              value={values.month_salary || ''}
                              onChange={handleChange}
                              fullWidth
                              disabled={props.dialogAction === EDialogAction.view}
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                              <InputLabel id="salary_currency-label">Salary Currency</InputLabel>
                              <Select
                                labelId="salary_currency-label"
                                id="salary_currency"
                                name="salary_currency"
                                value={values.salary_currency || ''}
                                onChange={handleChange}
                                label="Salary Currency"
                                disabled={props.dialogAction === EDialogAction.view}
                              >
                                <MenuItem value="AED">AED - UAE Dirham</MenuItem>
                                <MenuItem value="QR">QR - Qatar Riyal</MenuItem>
                                <MenuItem value="KWD">KWD - Kuwait Dinar</MenuItem>
                                <MenuItem value="SR">SR - Saudi Riyal</MenuItem>
                                <MenuItem value="OMR">OMR - Omani Riyal</MenuItem>
                                <MenuItem value="BD">BD - Bahrain Dinar</MenuItem>
                                <MenuItem value="LEI">LEI - Romanian Leu</MenuItem>
                                <MenuItem value="EUR">EUR - Euro (Cyprus)</MenuItem>
                                <MenuItem value="MYR">MYR - Malaysian Ringgit</MenuItem>
                                <MenuItem value="SGD">SGD - Singapore Dollar</MenuItem>
                                <MenuItem value="HKD">HKD - Hong Kong Dollar</MenuItem>
                                <MenuItem value="LKR">LKR - Sri Lankan Rupee</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} className="mt-2">
                          <Grid item xs={12}>
                            <TextField
                              label="Note"
                              name="note"
                              value={values.note || ''}
                              onChange={handleChange}
                              multiline
                              rows={3}
                              fullWidth
                              placeholder="Enter any additional notes..."
                              disabled={props.dialogAction === EDialogAction.view}
                            />
                          </Grid>
                        </Grid>

                        <Divider className="my-4" />

                        <Typography variant="subtitle1" gutterBottom>Requirements</Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={6}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">Training Needed?</FormLabel>
                              <RadioGroup
                                row
                                name="training_needed"
                                value={values.training_needed || 0}
                                onChange={(e) => setFieldValue("training_needed", parseInt(e.target.value))}
                              >
                                <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                <FormControlLabel value={0} control={<Radio />} label="No" />
                              </RadioGroup>
                            </FormControl>
                            {values.training_needed === 1 && (
                              <TextField
                                label="Training Amount"
                                name="training_amount"
                                type="number"
                                value={values.training_amount || ''}
                                onChange={handleChange}
                                InputProps={{ endAdornment: <InputAdornment position="end">LKR</InputAdornment> }}
                                fullWidth
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">Passport Needed?</FormLabel>
                              <RadioGroup
                                row
                                name="passport_needed"
                                value={values.passport_needed || 0}
                                onChange={(e) => setFieldValue("passport_needed", parseInt(e.target.value))}
                              >
                                <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                <FormControlLabel value={0} control={<Radio />} label="No" />
                              </RadioGroup>
                            </FormControl>
                            {values.passport_needed === 1 && (
                              <TextField
                                label="Passport Amount"
                                name="passport_amount"
                                type="number"
                                value={values.passport_amount || ''}
                                onChange={handleChange}
                                InputProps={{ endAdornment: <InputAdornment position="end">LKR</InputAdornment> }}
                                fullWidth
                              />
                            )}
                          </Grid>
                        </Grid>                      
                      </Card>
                    </>
                  ) : (
                    <div></div>
                  )}
                  {(resume?.rec_status && resume?.rec_status !== "0" && props.dialogAction !== EDialogAction.create) ? (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border">

                        <div className="flex justify-between">
                          <Typography variant="h2" fontSize={18}>Attachments</Typography>
                          {loading || attachmentLoading ? <CircularProgress size={24} /> : <></>}
                        </div>
                        <div className="grid grid-cols-3 mt-4">
                          <div className="flex flex-col space-y-1 mr-6 mb-4">
                            <div>
                              <FormControl>
                                <InputLabel id="file-label">
                                  File Type
                                </InputLabel>
                                <Select
                                  labelId="file-label"
                                  label="File Type"
                                  required
                                  disabled={
                                    props.dialogAction == EDialogAction.view
                                  }
                                  style={{ width: 250, fontSize: 14 }}
                                  id="file"
                                  defaultValue="PDF"
                                  value={values.file}
                                  // onChange={handleChange}
                                  onChange={(event, newValue: any) => {
                                    setValue(newValue.props.value);
                                  }}
                                  name="file"
                                  error={Boolean(touched.file && errors.file)}
                                >
                                  <MenuItem value={""}>
                                    <em>None</em>
                                  </MenuItem>
                                  <MenuItem value={"PDF"}>Pdf</MenuItem>
                                  <MenuItem value={"IMAGE"}>Image</MenuItem>
                                  <MenuItem value={"DOC"}>Doc</MenuItem>
                                  <MenuItem value={"VIDEO"}>Video</MenuItem>
                                </Select>
                              </FormControl>
                              <FormHelperText style={{ color: "red" }}>
                                {errors.file &&
                                  touched.file &&
                                  String(errors.file)}
                              </FormHelperText>
                            </div>
                          </div>
                          <div className="flex flex-col space-y-1 mr-10 mb-4">
                            <TextField
                              disabled={
                                props.dialogAction == EDialogAction.view
                              }
                              id="outlined-multiline-flexible"
                              multiline
                              label="Notes"
                              required
                              maxRows={2}
                              variant="outlined"
                              onChange={(e) => {
                                setNote(e.target.value);
                              }}
                              value={values.title}
                              placeholder="Enter Notes"
                              name="notes"
                              inputProps={{
                                style: {
                                  height: "16px",
                                  fontSize: "14px",
                                },
                              }}
                            />
                          </div>
                          <div className="flex flex-col space-y-1  mb-4">
                            <FormControl>
                              <InputLabel id="attachment_tag-label">
                                Attachment Type
                              </InputLabel>
                              <Select
                                disabled={
                                  props.dialogAction == EDialogAction.view
                                }
                                style={{ width: 250, fontSize: 14 }}
                                id="attachment_tag"
                                labelId="attachment_tag-label"
                                label="Attachment Type"
                                defaultValue="profile_pic"
                                value={values.image_type}
                                // onChange={handleChange}
                                onChange={(event, newValue: any) => {
                                  setAttachmentPath(newValue.props.value);
                                }}
                                name="attachment_tag"
                                error={Boolean(
                                  touched.attachment_tag &&
                                  errors.attachment_tag
                                )}
                              >
                                <MenuItem value={""}>
                                  <em>None</em>
                                </MenuItem>
                                <MenuItem value={"profile_pic"}>
                                  Profile Picture
                                </MenuItem>
                                <MenuItem value={"full_pic"}>
                                  Full Picture
                                </MenuItem>
                                <MenuItem value={"interview_video"}>
                                  Interview Video
                                </MenuItem>
                                <MenuItem value={"other"}>Others</MenuItem>
                              </Select>
                            </FormControl>
                            <FormHelperText style={{ color: "red" }}>
                              {errors.attachment_tag &&
                                touched.attachment_tag &&
                                String(errors.attachment_tag)}
                            </FormHelperText>
                          </div>

                          {/* <div id="app"> */}
                          {/* <img src={file?.source || defaultSrc} alt="preview" /> */}
                          {/* <button
                        onClick={() =>
                          selectFile({accept:'',multiple:true}, (files) => {
                            files.map(({ source, name, size, file }) =>{
                              console.log({ source, name, size, file })
                            })
                          })
                        }
                      >
                        Upload Avatar
                      </button> */}
                          {/* </div> */}
                        </div>

                        <div className="max-w-xl">
                          <div>
                            {props.dialogAction == EDialogAction.edit ? (
                              <Button
                                variant="contained"
                                color="primary"
                                disabled={loading || attachmentLoading}
                                endIcon={<AttachFile />}
                                onClick={() => openFileSelector()}
                              >
                                Select files
                              </Button>
                            ) : (
                              <></>
                            )}

                            <br />
                            {filesContent.map((file, index) => (
                              <Card key={index} className="p-3 m-3">
                                <p className="text-sm">{file.name}</p>
                                {props.dialogAction == EDialogAction.edit ? (
                                  <>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      className="m-1"
                                      disabled={loading || attachmentLoading}
                                      onClick={() => {
                                        addAttachment(resume.id);
                                      }}
                                    >
                                      {loading || attachmentLoading ? <><CircularProgress color="warning" size={15} className="mr-2" /> Uploading</> : 'Add'}
                                    </Button>
                                    <Button
                                      color="warning"
                                      disabled={loading || attachmentLoading}
                                      onClick={() => {
                                        clear();
                                      }}
                                    >
                                      <CancelIcon />
                                    </Button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Card>
                            ))}

                            <br />
                            <List>
                              {attachments.map((attachment: any, index) => (
                                <ListItem key={index} className="hover:bg-slate-50 rounded-md">
                                  <ListItemAvatar>
                                    {attachment.attachment_type === 'IMAGE' ? (
                                      <Avatar
                                        src={`${process.env.REACT_APP_PUBLIC_FILE_PATH}${attachment.attachment_url}`}
                                        alt={attachment.note}
                                      />
                                    ) : (
                                      <Avatar>{attachment.attachment_type}</Avatar>
                                    )}
                                  </ListItemAvatar>
                                  <ListItemText secondary={attachment.note} primary={AttachmentTagEnum[attachment.attachment_tag]} />
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    className="mx-2"
                                    disabled={loading || attachmentLoading}
                                    endIcon={<OpenInNew />}
                                    onClick={() => {
                                      window.open(`${process.env.REACT_APP_PUBLIC_FILE_PATH}${attachment.attachment_url}`, '_blank');
                                    }}
                                  >
                                    View
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color="error"
                                    disabled={loading || attachmentLoading}
                                    onClick={() => {
                                      deleteAttachment(attachment.id);
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </ListItem>
                              ))}
                            </List>
                          </div>

                        </div>
                        <TextField
                          disabled={props.dialogAction === EDialogAction.view}
                          id="remark"
                          label="Remark"
                          multiline
                          variant="outlined"
                          onChange={handleChange}
                          value={values.remark || ""}
                          placeholder="Enter Remark"
                          name="remark"
                          InputProps={{
                            classes: {
                              disabled: classes.disabled,
                            },
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          error={Boolean(errors.remark && touched.remark)}
                          helperText={
                            errors.remark &&
                            touched.remark &&
                            String(errors.remark)
                          }
                          fullWidth
                        />
                      </Card>
                    </>
                  ) : (
                    <></>
                  )}
                  {(resume?.rec_status && resume?.rec_status !== "0" && props.dialogAction !== EDialogAction.create) ? (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border">
                        <div className="flex items-center justify-between">
                          <Typography variant="h2" fontSize={18} className="mb-2">Passport Details</Typography>
                          <div className="flex items-center gap-4">
                            <FormControl>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={values.awaiting_passport}
                                    onChange={(e) => {
                                      setFieldValue("awaiting_passport", e.target.checked);
                                    }}
                                    value={values.awaiting_passport}
                                    name="awaiting_passport"
                                  />
                                }
                                label="Awaiting Passport"
                              />
                            </FormControl>
                            <FormControl>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={values.no_passport}
                                    onChange={(e) => {
                                      setFieldValue("no_passport", e.target.checked);
                                    }}
                                    value={values.no_passport}
                                    name="no_passport"
                                  />
                                }
                                label="No Passport"
                              />
                            </FormControl>
                          </div>
                        </div>
                        {!values.no_passport && (
                          <>
                            <div className="grid grid-cols-3 mt-4 mb-2">
                              <div className="flex flex-col space-y-1 mr-6 mb-4">
                                <TextField
                                  disabled={props.dialogAction == EDialogAction.view}
                                  id="passport_no"
                                  variant="outlined"
                                  onChange={handleChange}
                                  value={values.passport_no || ""}
                                  placeholder="Enter Passport Number"
                                  label="Passport Number"
                                  name="passport_no"
                                  required
                                  InputProps={{
                                    classes: {
                                      disabled: classes.disabled,
                                    },
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  error={Boolean(
                                    errors.passport_no && touched.passport_no
                                  )}
                                  helperText={
                                    errors.passport_no &&
                                    touched.passport_no &&
                                    String(errors.passport_no)
                                  }
                                />
                              </div>
                              <div className="flex flex-col space-y-1 mr-6 mb-4">
                                <TextField
                                  disabled={props.dialogAction == EDialogAction.view}
                                  id="passport_place_of_issue"
                                  variant="outlined"
                                  onChange={handleChange}
                                  value={values.passport_place_of_issue || ""}
                                  placeholder="Enter Place of Issue"
                                  label="Place of Issue"
                                  required
                                  name="passport_place_of_issue"
                                  InputProps={{
                                    classes: {
                                      disabled: classes.disabled,
                                    },
                                    style: {
                                      fontSize: "14px",
                                    },
                                  }}
                                  error={Boolean(
                                    errors.passport_place_of_issue &&
                                    touched.passport_place_of_issue
                                  )}
                                  helperText={
                                    errors.passport_place_of_issue &&
                                    touched.passport_place_of_issue &&
                                    String(errors.passport_place_of_issue)
                                  }
                                />
                              </div>

                              <div className="flex flex-col space-y-1 mr-6 mb-4">
                                <CustomDatePicker
                                  name="passport_date_of_issue"
                                  label="Date of Issue"
                                  isRequired={true}
                                  maxDate={new Date()}
                                  onUpdate={(field: any, value: any) => {
                                    setFieldValue('passport_date_of_issue', value || "");
                                    const expireDate = new Date(value);
                                    expireDate.setFullYear(expireDate.getFullYear() + 10);
                                    values.passport_expire_date = expireDate.toISOString().split("T")[0];
                                  }}
                                />
                                {/* <TextField
                                disabled={props.dialogAction == EDialogAction.view}
                                id="passport_date_of_issue"
                                variant="outlined"
                                onChange={handleChange}
                                value={values.passport_date_of_issue || ""}
                                placeholder="Enter Date of Issue"
                                
                                name="passport_date_of_issue"
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                  style: {
                                  
                                    fontSize: "14px",
                                  },
                                }}
                                error={Boolean(
                                  errors.passport_date_of_issue &&
                                    touched.passport_date_of_issue
                                )}
                                helperText={
                                  errors.passport_date_of_issue &&
                                    touched.passport_date_of_issue &&
                                    String(errors.passport_date_of_issue)
                                }
                              /> */}
                              </div>

                              <div className="flex flex-col space-y-1 mr-6 mb-4">
                                <CustomDatePicker
                                  name="passport_expire_date"
                                  label="Expire Date"
                                  isRequired={true}
                                  onUpdate={(field: any, value: any) => {
                                    setFieldValue('passport_expire_date', value || "");
                                  }}
                                />

                                {/* <TextField
                                disabled={props.dialogAction == EDialogAction.view}
                                id="passport_expire_date"
                                variant="outlined"
                                onChange={handleChange}
                                value={values.passport_expire_date || ""}
                                placeholder="Enter Expiration Date"
                                
                                name="passport_expire_date"
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                  style: {
                                  
                                    fontSize: "14px",
                                  },
                                }}
                                error={Boolean(
                                  errors.passport_expire_date &&
                                    touched.passport_expire_date
                                )}
                                helperText={
                                  errors.passport_expire_date &&
                                    touched.passport_expire_date &&
                                    String(errors.passport_expire_date)
                                }
                              /> */}
                              </div>
                            </div>
                            {props.dialogAction !== EDialogAction.view && (
                              <div className="flex justify-end mt-2">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={passportLoading}
                                  onClick={async () => {
                                    await savePassportDetails(values);
                                  }}
                                >
                                  {passportLoading ? <CircularProgress size={24} color="inherit" /> : "Save"}
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                      </Card>
                      <Divider className="my-3" />
                      <Card className="p-3 border">
                        {/* <Typography variant="h2" fontSize={18}>Country Process</Typography> */}
                        <Typography variant="h2" fontSize={18}>Selected Job Details</Typography>
                        <div className="grid grid-cols-3 mt-4">
                          <div className="flex space-x-2 justify-start mb-4">
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={countryProcessList}
                              getOptionLabel={(option) =>
                                option.title + " | " + option.country_name
                              }
                              onChange={(e, value) =>
                                setCountryProcessId(value?.id)
                              }
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onOpen={handleCountryProcessesChange}
                              onInputChange={handleCountryProcessInputChange}
                              filterOptions={(x) => x}
                              renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                  {option.title} | {option.country_name}
                                </li>
                              )}
                              sx={{ width: 260, height: 25 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="country_process_id"
                                  placeholder={
                                    values!
                                      ? "Select the Country Process"
                                      : resume.country_process_id
                                  }
                                  label="Country Process"
                                />
                              )}
                            />
                            {(props.dialogAction === EDialogAction.edit && (resumeCountryProcessList == null || resumeCountryProcessList.length === 0 || allRejected)) && (
                              <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={() => {
                                  addCountryProcess(resume.id);
                                }}
                              >
                                Add
                              </Button>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                          {(resumeCountryProcessList && resumeCountryProcessList.length > 0) && (
                            resumeCountryProcessList.map((data, index) => {
                              return (
                                <div key={index}>
                                  <Card
                                    className={'border'}
                                    elevation={0}
                                    key={index}
                                    sx={{
                                      minHeight: "135px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <CardContent>
                                      <Typography
                                        sx={{ fontSize: 14 }}
                                        color="text.secondary"
                                      >
                                        {data.country_process.country_name}
                                      </Typography>
                                      <Typography sx={{ fontSize: 18 }}>
                                        {data.country_process.title}
                                      </Typography>
                                    </CardContent>
                                    <CardActions className="flex-1">
                                      <div className="relative flex items-center justify-between gap-2">
                                        {data.status === "created" ? (
                                          <>
                                            {!resume.no_passport && (
                                              <div className="flex-initial mt-2">
                                                <Button
                                                  variant="contained"
                                                  color="success"
                                                  onClick={() => {
                                                    syncProcesses(
                                                      data.country_process.id, ProcessEnum.processing
                                                    );
                                                  }}
                                                  className="w-full"
                                                >
                                                  Register
                                                </Button>
                                              </div>
                                            )}
                                            <div className="flex-initial mt-2">
                                              <Button
                                                variant="contained"
                                                color="warning"
                                                onClick={() => {
                                                  syncProcesses(
                                                    data.country_process.id, ProcessEnum.candidateRejected
                                                  );
                                                }}
                                                className="w-full"
                                              >
                                                Candidate Reject
                                              </Button>
                                            </div>
                                            <div className="flex-initial mt-2">
                                              <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => {
                                                  syncProcesses(
                                                    data.country_process.id, ProcessEnum.rejected
                                                  );
                                                }}
                                                className="w-full"
                                              >
                                                Reject
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className="flex-initial mt-2">
                                              <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => {
                                                  gotoProcessViewPageChangeHandler(
                                                    data.process_id
                                                  );
                                                }}

                                              >
                                                <OpenInNew />
                                              </Button>
                                            </div>
                                            <div className="flex-initial mt-2 text-end mr-1">
                                              <Chip
                                                label={ProcessEnumDisplayLabel[data.status]}
                                                color={
                                                  data.status == ProcessEnum.started ||
                                                    data.status == ProcessEnum.processing ||
                                                    data.status == ProcessEnum.completed
                                                    ? "success"
                                                    : "error"
                                                }
                                                variant="filled"

                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>

                                      {/* {props.dialogAction == EDialogAction.edit ? (
                                  <button
                                    className="bg-red-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded ml-2 text-xs"
                                    onClick={() => {
                                      deleteCountryProcess(data.id);
                                    }}
                                  >
                                    Remove */}
                                      {/* <CancelIcon
                                      className="ml-2 cursor-pointer"
                                      fontSize="inherit"
                                    /> */}
                                      {/* </button>
                                ) : (
                                  <></>
                                )} */}
                                    </CardActions>
                                  </Card>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </Card>
                    </>
                  ) : (
                    <div></div>
                  )}
                  {(resume?.rec_status && resume?.rec_status !== "0" && props.dialogAction !== EDialogAction.create) ? (
                    <>
                      <Divider className="my-3" />
                      <Card className="p-3 border" aria-disabled={jobDataLoading}>
                        {/* <Typography variant="h2" fontSize={18}>Job List</Typography> */}
                        <Typography variant="h2" fontSize={18}>Skills</Typography>
                        <div className="grid grid-cols-2 gap-2 mt-2">

                          {Array.from(new Set(resumeCountryProcessList?.map(item => item.country_process.job_title_id)), (jobTitleId) => {
                            const data = resumeCountryProcessList?.find(item => item.country_process.job_title_id === jobTitleId);
                            return (
                              <Card className="border" key={jobTitleId}>
                                {jobDataLoading && <LinearProgress />}
                                <CardContent>
                                  <div className="flex justify-between">
                                    <Typography variant="h5" fontSize={18} component="div" className="mb-2">
                                      {data.country_process.title}
                                    </Typography>
                                  </div>
                                  <Divider className="my-2" />
                                  <List>
                                    {jobSkillList?.[jobTitleId]?.map((skill: { skill: { skill_name: string; skill_id: number; description?: string }; skill_id: string, skill_level?: string }, index: number) => (
                                      <div key={index} className="flex justify-between items-center mb-2 border-b">
                                        <div>
                                          {skill.skill?.skill_name}
                                          <sup>
                                            <Tooltip title={skill.skill?.description}>
                                              <IconButton disableRipple><InfoRounded fontSize="small" color={skill.skill_level ? "action" : "info"} /></IconButton>
                                            </Tooltip>
                                          </sup>
                                        </div>
                                        <FormControl>
                                          <RadioGroup
                                            row
                                            value={skill.skill_level}
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="skill_level"
                                            onChange={(event) => {
                                              let updatedJobSkillList = { ...jobSkillList };
                                              for (let jobTitleId in updatedJobSkillList) {
                                                for (let sk of updatedJobSkillList[jobTitleId]) {
                                                  if (sk.skill_id === skill.skill_id) {
                                                    sk.skill_level = event.target.value;
                                                  }
                                                }
                                              }

                                              setJobSkillList(updatedJobSkillList);
                                              createSkillLevel(skill.skill_id, event.target.value);
                                            }}
                                          >
                                            {Object.entries(SkillLevelEnum)
                                              .filter(([key, value]) =>
                                                (data.country_process.pdf_template !== 'exp' && data.country_process.pdf_template !== 'non_exp') ? value !== SkillLevelEnum.good : true
                                              )
                                              .map(([key, value]) => (
                                                <FormControlLabel
                                                  key={key}
                                                  value={value}
                                                  disabled={jobDataLoading}
                                                  control={<Radio size="small" />}
                                                  checked={skill.skill_level === value}
                                                  label={SkillLevelDisplayEnum[value]}
                                                  labelPlacement="start"
                                                  classes={{ label: classes.checkboxLabel }}
                                                />
                                              ))}
                                          </RadioGroup>
                                        </FormControl>
                                      </div>
                                    ))}
                                  </List>
                                </CardContent>
                              </Card>
                            );
                          })}
                        </div>
                      </Card>
                      <Card className="mt-4">
                        <CardHeader
                          title="Extra"
                          titleTypographyProps={{ variant: "h6" }}
                        />
                        <Divider className="m-0" />
                        <CardContent>
                          <Typography variant="body1" className="mb-2">
                            Title: {jobTitleExtraTitle}
                          </Typography>
                          <List>
                            <div className="grid grid-cols-3 gap-2">
                              {jobTitleExtra &&
                                jobTitleExtra.map((extra: any, index: number) => (
                                  <ListItem key={index}>
                                    <FormControl>
                                      <FormControlLabel
                                        control={
                                          <Checkbox className="py-0"
                                            checked={jobTitleExtraChecked.includes(extra)}
                                            onChange={(e) =>
                                              setJobTitleExtraChecked(
                                                e.target.checked
                                                  ? [...jobTitleExtraChecked, extra]
                                                  : jobTitleExtraChecked.filter((item: any) => item !== extra)
                                              )
                                            }
                                          />
                                        }
                                        label={extra}
                                        labelPlacement="end"
                                        classes={{
                                          label: classes.checkboxLabel,
                                        }}
                                      />
                                    </FormControl>
                                  </ListItem>
                                ))}
                            </div>
                          </List>
                        </CardContent>
                      </Card>
                    </>
                  ) : (
                    <> </>
                  )}
                  <Divider className="pt-4" />
                  <div className="flex py-3 px-3 space-x-4 justify-center">
                    {props.dialogAction !== EDialogAction.view ? (
                      <Button
                        variant="contained"
                        color="primary"
                        className="ml-4 my-1"
                        onClick={async () => {
                          const errorList = await validateForm()
                          Object.keys(errorList).forEach(fieldName => {
                            setFieldTouched(fieldName, true);
                            setFieldError(fieldName, errorList[fieldName]?.toString());
                          });
                          const formErrors = Object.values(errorList).some(error => error);

                          if (!formErrors) {
                            handleSubmit();
                          }
                        }}
                      >
                        {props.dialogAction === EDialogAction.edit
                          ? "Update"
                          : "Create"}
                      </Button>
                    ) : (
                      <></>
                    )}
                    <Button
                      variant="contained"
                      color="secondary"
                      className="ml-4 my-1"
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ResumeDialogBox;
